/**
 * @license
 * @qwik.dev/core 2.0.0-beta.38-dev+b9ad024
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ce, isBrowser as Oe } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as Ne } from "@qwik.dev/core/preloader";

const je = !1;

const Fe = (t, ...n) => De(!1, t, ...n);

const De = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const Xe = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const We = (t, n, e, s, o = !1) => {
    const r = Xe(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const Ve = (t, n, e) => {
    const s = Xe(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ue = (t, n, e) => Xe(t, n, e) >= 0;

const ze = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Be = t => typeof t === "object" && t !== null;

const Qe = t => Array.isArray(t);

const He = t => typeof t === "string";

const Je = t => typeof t === "function";

const Ye = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = De(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Ge = "<sync>";

const Ke = t => typeof t === "function" && typeof t.getSymbol === "function";

const sd = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Ze = "q:type";

const ti = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const ii = 124;

const ri = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const si = "q:renderFn";

const oi = "q:targetEl";

const li = "⚡️";

const ui = "q:slot";

const ci = "q:s";

const fi = "[q\\:patch]";

const ai = "q:r";

const od = "q:rp";

const hi = "q:style";

const di = "style[q\\:style]";

const pi = di + ",style[q\\:sstyle]";

const $i = "q:sstyle";

const yi = "q:ctx";

const mi = "q:brefs";

const wi = (t, n) => t["qFuncs_" + n] || [];

const vi = "q:base";

const bi = "q:container-island";

const _i = "/" + bi;

const gi = "q:ignore";

const Ei = "/" + gi;

const Si = "q:container";

const ki = "/" + Si;

const Ri = "q:cursorBoundary";

const Pi = "q:template";

const Ti = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const qi = "http://www.w3.org/1999/xhtml";

const Ai = "http://www.w3.org/2000/svg";

const Mi = "http://www.w3.org/1998/Math/MathML";

const xi = "qRender";

const Ii = "q:id";

const Ni = "q:key";

const Ci = "q:props";

const Oi = "q:seq";

const ji = "q:seqIdx";

const Li = "q:p";

const Fi = "q:ps";

const Xi = ":on";

const Wi = ":onIdx";

const Vi = ":onFlags";

const Ui = ":nearestCursorBoundary";

const zi = ":";

const Bi = "dangerouslySetInnerHTML";

const Hi = 100;

const Ji = t => !!t && typeof t == "object" && typeof t.then === "function";

const Yi = (t, n, e) => {
    try {
        const s = t();
        return Ji(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const Gi = (t, n) => Ji(t) ? t.then(n) : n(t);

const Ki = t => new Promise(n => {
    setTimeout(n, t);
});

const Zi = t => {
    throw t;
};

function n(t, n = Zi) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!Ji(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Hi;
    const r = async e => {
        for (;Ji(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!Ji(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const tr = t => li + t;

const nr = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + tr(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const er = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + ir(t.slice(s, -1));
        }
    }
    return null;
}

const ir = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = rr(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const rr = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const sr = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const or = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const lr = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const ur = t => {
    if (!t) {
        return "";
    }
    if (He(t)) {
        return t.trim();
    }
    const n = [];
    if (Qe(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = ur(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const cr = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const fr = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Qe(t)) {
            throw Ye(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(cr(e) + ":" + ar(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function i(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = ur(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = fr(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const ar = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => or.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const hr = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.cn = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const dr = () => ({
    isServer: Ce,
    importSymbol(t, n, e) {
        if (Ce) {
            const t = sd(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Ye(6, [ e ]);
        }
        if (!n) {
            throw Ye(14, [ e ]);
        }
        if (!t) {
            throw Ye(13, [ n, e ]);
        }
        const s = pr(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const pr = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(vi) ?? s, s);
    return new URL(e, o);
};

let $r = /*#__PURE__ */ dr();

const yr = t => $r = t;

const mr = () => $r;

const rd = () => $r.isServer;

const id = typeof document !== "undefined";

const wr = !Ce && id;

const vr = wr ? document : void 0;

const br = wr && vr.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const _r = /\.[mc]?js$/;

const gr = t => {
    let n = Er.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            fn: t,
            zt: _r.test(t) ? 0 : 3,
            an: n,
            hn: 1,
            dn: performance.now(),
            pn: 0,
            $n: 0
        }))(t, e);
        Er.set(t, n);
    }
    return n;
};

const Er = new Map;

let Sr = 0;

const kr = [];

const Rr = hr(function cd() {
    Tr = !1;
    if (!kr.length) {
        return;
    }
    const t = performance.now() + 10;
    let n = !1;
    for (;kr.length; ) {
        const e = kr[0];
        const s = e.hn;
        const o = 1 - s;
        if (!(o >= .99 || Sr < 25)) {
            break;
        }
        kr.shift();
        Ir(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && kr.length && !Tr) {
        Tr = !0;
        Rr();
    }
});

const Pr = hr(r);

let Tr = !1;

let qr = !1;

let Ar = !1;

const Mr = [];

const xr = () => {
    const t = Mr[Mr.length - 1];
    const n = t.yn;
    if (t.an) {
        const e = t.Nt;
        if (e >= t.an.length) {
            Mr.pop();
            return !1;
        }
        const s = t.an[e];
        t.Nt = e + 1;
        const o = gr(s.fn);
        if (o.hn === 0) {
            return !0;
        }
        const r = 1 - n.hn;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.mn);
        } else {
            const t = 1 - s.mn * r;
            const n = s.wn;
            const e = t / n;
            i = Math.max(.02, o.hn * e);
            s.wn = e;
        }
        Mr.push({
            yn: o,
            hn: i,
            vn: t.vn
        });
        return !0;
    }
    if (t.vn?.has(n)) {
        Mr.pop();
        return !1;
    }
    const e = n.hn;
    n.hn = t.hn;
    if (e - n.hn < .01) {
        Mr.pop();
        return !1;
    }
    if (n.an?.length) {
        const e = t.vn || new Set;
        e.add(n);
        t.vn = e;
        t.an = n.an;
        t.Nt = 0;
        return !1;
    }
    Mr.pop();
    return !1;
};

function r() {
    if (Ar || !Mr.length) {
        return;
    }
    qr = !1;
    Ar = !0;
    const t = wr ? performance.now() + 10 : 0;
    let n = !1;
    for (;Mr.length; ) {
        n = !0;
        const e = xr();
        if (wr && e && performance.now() >= t) {
            if (!qr) {
                qr = !0;
                Pr();
            }
            break;
        }
    }
    Ar = !1;
    n && wr && Rr();
}

const Ir = t => {
    if (t.zt >= 2) {
        return;
    }
    Sr++;
    const n = performance.now();
    t.pn = n - t.dn;
    t.zt = 2;
    const e = vr.createElement("link");
    e.href = new URL("undefined" + t.fn, vr.baseURI).toString();
    e.rel = br;
    e.as = "script";
    e.onload = e.onerror = () => {
        Sr--;
        const s = performance.now();
        t.$n = s - n;
        t.zt = 4;
        e.remove();
        Rr();
    };
    vr.head.appendChild(e);
};

const Nr = (t, n) => {
    const e = gr(t);
    e && ((t, n) => {
        Mr.unshift({
            yn: t,
            hn: n,
            vn: void 0
        });
    })(e, n);
};

wr && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Nr(e, 0);
                }
            } else {
                Nr(t, 0);
            }
            wr ? Pr() : r();
        })(t);
    }
});

const Cr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const Or = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const jr = '"';

const Lr = "[";

const Fr = "]";

const Dr = ",";

const Xr = "2.0.0-beta.38-dev+b9ad024";

const Wr = t => t.nodeType === 1;

const ld = t => t.Jn;

const Vr = Symbol();

class Ur {
    [Vr]=void 0;
}

const zr = t => t === "foreignObject";

const Br = t => t === "svg" || zr(t);

const Qr = t => t === "math";

function s(t, n, e, o = !1) {
    const r = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== zi && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(s(i, i.localName, e, o));
        }
    }
    return r;
}

const Hr = {
    elementNamespace: qi,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!Ql(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && zr(Ql(t));
    let o = qi;
    let r = 0;
    const i = typeof n === "string" || $l(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Br(t);
        }
        if ($l(t)) {
            return Br(Ql(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Ai;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Qr(t);
        }
        if ($l(t)) {
            return Qr(Ql(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Mi;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Ai : e ? Mi : qi;
        r = t.flags & 1536;
    }
    Hr.elementNamespace = o;
    Hr.elementNamespaceFlag = r;
    return Hr;
}

class Jr {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Vr]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Yr extends Jr {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Gr extends Yr {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Kr extends Jr {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Zr = [];

const ts = [];

function l(t, n) {
    const e = y(n).priority;
    let s = Zr.length;
    for (let t = 0; t < Zr.length; t++) {
        const n = y(Zr[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Zr.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Zr.length; t++) {
        const n = Zr[t];
        let e = !1;
        for (let t = 0; t < ts.length; t++) {
            const s = ts[t];
            if ($u(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    ts.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = Zr.indexOf(t);
    if (s !== -1) {
        Zr.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = ts.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = ts.length - 1;
    e !== s && (ts[e] = ts[s]);
    ts.pop();
    n.o--;
    return !0;
}

const ns = new WeakMap;

const es = ":nodeProps";

const is = ":nodeDiff";

const rs = ":errorData";

const ss = ":signal";

const os = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && dn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return ns.get(t) ?? null;
}

const ls = Symbol();

const us = Symbol();

const cs = Symbol();

const fs = Symbol();

const as = Symbol();

const hs = Symbol();

const ds = [];

const ps = {};

Object.freeze(ds);

Object.freeze(ps);

function m(t) {
    return new Proxy({}, new $s(t));
}

class $s {
    owner;
    ft=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === ls) {
            return this.owner.constProps;
        }
        if (n === us) {
            return this.owner.varProps;
        }
        if (n === cs) {
            return this.owner;
        }
        if (n === fs) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = ws(this.owner, n);
            n in this.owner.varProps && ys(this, n);
        }
        return s instanceof Js ? s.value : s;
    }
    set(t, n, s) {
        if (n === cs) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === ls) {
            this.owner.constProps = s;
        } else if (n === us) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === ps ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                ms(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ms(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === ls || n === us) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && ys(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const ys = (t, n) => {
    const e = xf();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.sn;
    s && In(t.owner._proxy, n, t, s);
};

const ms = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ft, n);
    e && Nu(t.$, t, e);
    return !!e;
};

const ws = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const vs = (t, n) => bs(t)?.[n] || _s(t)?.[n] || null;

const bs = t => {
    if (!t) {
        return null;
    }
    return us in t ? "children" in t ? {
        ...t[us],
        children: t.children
    } : t[us] : t;
};

const _s = t => {
    if (!t) {
        return null;
    }
    return ls in t ? t[ls] : null;
};

const gs = t => t && us in t;

const Es = Symbol();

class Ss {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const ks = Symbol();

const Rs = Symbol();

const Ps = Symbol();

function w(t, n, e) {
    t[Vr] || (Ce && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(mi, new Map) : t[Vr] = new Map);
    const o = t[Vr];
    let r = o.get(n);
    if (!r) {
        r = new Ss(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Ts = (t, n) => (e, s) => {
    const o = xe();
    o.sn = w(t, ":");
    o.$ = n || void 0;
    return qe(o, () => {
        if (Je(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (qu(e)) {
            return e.value;
        }
        if (Be(e) && zu(e)) {
            In(Xu(e), Ps, Du(e), o.sn);
            return e;
        }
        throw Ye(2);
    });
};

class qs {
    Ct;
    ft=void 0;
    $=null;
    bn=null;
    constructor(t, n) {
        this.$ = t || xf()?.$ || null;
        this.Ct = n;
    }
    trigger() {
        Nu(this.$, this, this.ft);
    }
    force() {
        Nu(this.$, this, this.ft);
    }
    get untrackedValue() {
        return this.Ct;
    }
    set untrackedValue(t) {
        this.Ct = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = xf();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.sn;
        if (e) {
            const t = Ce;
            const s = this.ft ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            Au(s, e);
            Mu(e, this);
            if (t) {
                const t = Iu(n.$, this.$);
                o && t?._n?.(this, e, null);
                xu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Ct) {
            this.Ct = t;
            Nu(this.$, this, this.ft);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Ct
        };
    }
}

class As {
    gn;
    En=null;
    Sn=!1;
    kn=!0;
    constructor(t, n, e) {
        this.gn = t;
        if (n !== void 0) {
            this.info = n;
            this.Rn = e;
        }
    }
    get track() {
        return this.Pn ||= Ts(this.gn, this.gn.$);
    }
    get abortSignal() {
        return (this.Tn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.gn.Ct;
        if (t !== Es) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.qn ||= []).push(t);
    }
}

class Ms extends qs {
    Ot;
    h;
    [Vr]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || xf()?.$, Es);
        this.Ot = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Ct = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.Ft = r;
            this.Dt = [];
        }
        s.timeout && (this.Xt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
        s.allowStale === !1 && (this.h |= 128);
        const i = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        i && (this.expires = i);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    invalidate(t) {
        if (arguments.length > 0) {
            this.An = t;
            this.Rn = this.Rn === void 0 ? 1 : this.Rn + 1;
        }
        if (this.h & 512) {
            this.Mn(!0, this.h & 128);
            return;
        }
        this.h |= 1;
        const e = xe();
        e.$ = this.$ || void 0;
        const s = n(Ae.bind(this, e, this.p));
        Ji(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.An = void 0;
            if (this.Dt) {
                for (let t = 0; t < this.Dt.length; t++) {
                    this.Dt[t].kn = !1;
                }
            } else {
                this.ot && (this.ot.kn = !1);
            }
            this.xn();
            super.value = t;
            this.In();
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.ot?.En) {
            if (this.Ct === Es || Ce) {
                throw this.ot?.En;
            }
            return this.Ct;
        }
        if (this.jt) {
            throw this.jt;
        }
        if (Ce && this.h & 64 && this.Ct === Es) {
            throw Ye(35);
        }
        return this.Ct;
    }
    set untrackedValue(t) {
        this.Ct = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = xf();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.sn;
            if (t) {
                Au(this.yt ||= new Set, t);
                Mu(t, this);
                xu(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Lt) {
            this.Lt = t;
            Nu(this.$, this, this.yt);
        }
    }
    get untrackedPending() {
        this.p();
        if (Ce && this.ot?.En) {
            throw this.ot?.En;
        }
        return !!this.Lt;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = xf();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.sn;
            if (t) {
                Au(this.wt ||= new Set, t);
                Mu(t, this);
                xu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.jt) {
            this.jt = t;
            Nu(this.$, this, this.wt);
        }
    }
    get untrackedError() {
        this.p();
        if (Ce && this.ot?.En) {
            throw this.ot?.En;
        }
        return this.jt;
    }
    get expires() {
        return this.Tt || 0;
    }
    set expires(t) {
        this.xn();
        this.Tt = t;
        this.Tt && this.Nn() && this.In();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.Tt && this.Nn()) {
            this.xn();
            this.In();
        }
    }
    get interval() {
        const t = this.Tt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    Mn(t, n) {
        this.h |= 1;
        this.xn();
        n && (this.Ct = Es);
        t && (this.ft?.size || this.yt?.size || this.wt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.ot && this.Cn(this.ot, t);
    }
    vt() {
        if (!(this.h & 32) || this.Nn()) {
            return;
        }
        if (!Oe) {
            return;
        }
        setTimeout(() => {
            this.Nn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.ot?.En; ) {
            await (this.ot?.En);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.On();
        }
        const t = this.Ot;
        Tu(t);
        const e = this.ot;
        if (e && !e.Sn) {
            e.Sn = !0;
            e.Tn?.abort();
            this.jn(e);
        }
        const s = new As(this, this.An, this.Rn);
        this.ot = s;
        let o;
        try {
            o = this.Ln(t.resolved, s);
        } catch (t) {
            if (Ji(t)) {
                throw t;
            }
            s.Rn === this.Rn && (this.An = void 0);
            this.h &= -2;
            this.Fn(s, t);
            return;
        }
        if (Ji(o)) {
            this.h |= 512;
            this.h &= -2;
            let t = o;
            const e = () => {
                const n = t ?? this.Ln(this.Ot.resolved, s);
                t = void 0;
                return n;
            };
            s.En = this.Dn(s, () => n(e));
            return;
        }
        s.Rn === this.Rn && (this.An = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    Ln(t, n) {
        const e = t;
        if (this.h & 1024) {
            let t = xf();
            t?.sn && (t = {
                ...t,
                sn: void 0
            });
            return Ae(t, e, [ n ]);
        }
        const s = this.$ ||= xf()?.$ || null;
        const o = w(this, ".");
        s && Rn(s, o);
        const r = xe();
        r.$ = s || void 0;
        r.sn = o;
        return Ae(r, e, [ n ]);
    }
    On() {
        if (Ce && this.h & 64) {
            this.Lt = !0;
            this.$?.serializationCtx.qt.add(this);
            return;
        }
        this.xn();
        this.h &= -2;
        const t = this.ot;
        t && this.Cn(t);
        const n = this.Ft === 0 ? Infinity : this.Ft ?? 1;
        if (this.Dt ? this.Dt.length >= n : t?.En) {
            this.h |= 1;
            return;
        }
        const e = this.Rn;
        const s = new As(this, this.An, e);
        this.ot = s;
        this.Dt && this.Dt.push(s);
        s.En = this.Xn(s);
    }
    async Xn(t) {
        let e = this.Ot.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Ot.resolve();
            if (t.Tn?.signal.aborted) {
                t.En = null;
                return;
            }
        }
        this.Xt && (this.Wn = setTimeout(() => {
            const n = Error(`timeout ${this.Xt}ms`);
            this.Fn(t, n);
            t.Tn?.abort(n);
        }, this.Xt));
        return this.Dn(t, () => n(() => this.Ln(e, t)));
    }
    async Dn(t, n) {
        try {
            const e = n();
            let s;
            if (Ji(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.En = null;
            if (t.kn) {
                const n = this.Dt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].kn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.En = null;
            this.Fn(t, n);
        }
        if ((() => t === this.ot)()) {
            clearTimeout(this.Wn);
            t.Rn === this.Rn && (this.An = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedPending = !1;
                this.In();
            }
        }
    }
    Fn(t, n) {
        if (t !== this.ot || !t.kn) {
            return;
        }
        t.kn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Es;
    }
    async cn() {
        this.xn();
        clearTimeout(this.Wn);
        const t = this.ot;
        t && this.Cn(t);
        this.Dt ? await Promise.all(this.Dt.map(t => t.En)) : await (t?.En);
    }
    xn() {
        if (this.Vn !== void 0) {
            clearTimeout(this.Vn);
            this.Vn = void 0;
        }
    }
    In() {
        if (Ce || !this.Tt) {
            return;
        }
        this.xn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.Vn = setTimeout(() => this.Mn(t, n), this.Tt);
        this.Vn?.unref?.();
    }
    Nn() {
        return !!(this.ft?.size || this.yt?.size || this.wt?.size);
    }
    Cn(t, n) {
        if (t.Sn) {
            return;
        }
        t.Sn = !0;
        t.Tn?.abort(n);
        t.En = Gi(t.En, () => this.Un(t));
    }
    jn(t) {
        const n = t.qn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    Ji(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Un(t) {
        const n = () => {
            t.En = null;
            const n = this.Dt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.jn(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const xs = t => (n, ...e) => t.call(null, da(n), ...e);

class Is extends Ms {
    constructor(t, n) {
        super(t, n, 17);
    }
    zn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Tu(this.Ot);
        const t = Of(this.Ot.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Ct === Es ? e : this.Ct;
        const r = Lf(() => this.zn ? s?.(o) || o : n(o), this, ".", this.$);
        this.zn = !0;
        this.h &= -2;
        const i = this.zn && r !== "undefined" || r !== this.Ct;
        if (i) {
            this.Ct = r;
            Nu(this.$, this, this.ft);
        }
    }
}

class Ns extends Ms {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const Cs = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Os = (t, n) => new Ms(n?.container || null, t, Ou(n?.serializationStrategy || "always"), n);

const js = (t, n) => new Ns(n?.container || null, t, Ou(n?.serializationStrategy || "always"), n);

const Ls = t => new Is(null, t);

const Fs = t => new qs(null, t);

const Ds = /*#__PURE__*/ xs(Os);

const Xs = /*#__PURE__*/ xs(js);

const Ws = xs(Ls);

const Vs = t => t.value;

const Us = (t, n) => t[n];

const zs = t => {
    if (t.length === 1) {
        if (qu(t[0])) {
            return t[0].bn ||= new Js(null, Vs, t, null);
        }
        if (zu(t[0])) {
            return new Js(null, Vs, t, null);
        }
        return t[0].value;
    }
    return new Js(null, Us, t, null);
};

const Bs = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Be(n)) {
        return n[e];
    }
    if (qu(n)) {
        if (n instanceof Js) {
            return n;
        }
        return zs(t);
    }
    if (gs(n)) {
        const s = n[ls];
        const o = n[us];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Qs(n, t);
        }
    } else {
        const s = Xu(n);
        if (s) {
            const n = s[e];
            return Qs(n, t);
        }
    }
    return n[e];
};

const Qs = (t, n) => qu(t) ? t : zs(n);

const Hs = (t, n) => {
    const e = Bs(t, n);
    if (e === as) {
        return t[n];
    }
    return e;
};

class Js extends qs {
    ut;
    lt;
    Rt;
    h;
    m=void 0;
    [Vr]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, Es);
        this.ut = e;
        this.lt = n;
        this.Rt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this.m) {
                this.$.setHostProp(this.m, ss, this);
                yn(this.$, this.m, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Nu(this.$, this, this.ft);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Ct;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Lf(() => this.lt(...this.ut), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Ct;
        if (n) {
            this.h |= 2;
            this.Ct = t;
        }
    }
    rt() {
        return this.lt === Vs && qu(this.ut[0]) ? this.ut[0] : this;
    }
    set value(t) {
        throw Ye(31);
    }
    get value() {
        return super.value;
    }
}

class Ys {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class Gs {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Cr(n) ? ps : n;
        this.constProps = !e || Cr(e) ? null : e;
    }
    get props() {
        return this._proxy ||= m(this);
    }
}

const Ks = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Zs = t => t instanceof Gs;

const to = (t, n, e) => {
    if (typeof t === "string") {
        const s = Ee(n);
        return Tf(s, () => {
            ta(na(s, t));
            return e();
        });
    }
    return e();
};

function v(t, n) {
    return to(this, n, () => {
        const t = Zf[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function b(t, n) {
    return to(this, n, () => {
        const t = Zf[0];
        t.value = n.checked;
    });
}

function _(t, n) {
    return to(this, n, () => {
        if (Zf) {
            for (let t = 0; t < Zf.length; t++) {
                const n = Zf[t];
                n instanceof Ns && n.h & 64 && n.p();
            }
        }
    });
}

const no = "bind:value";

const eo = "bind:checked";

const io = "passive:";

const ro = "preventdefault:";

const so = Object.prototype.hasOwnProperty;

const oo = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(ir(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const lo = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return ir(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return ir(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return ir(t.slice(11, -1));
    }
    return null;
};

const uo = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = lo(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const co = (t, n, e, s, o, r, i) => new Gs(t, n, e, s, o, r, !1, i);

const fo = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(io)) {
                    r.push(o);
                    t.add(ir(o.slice(8)));
                } else {
                    o.startsWith(ro) ? h.push(o) : lo(o) !== null ? s.push(o) : o === eo ? a = e[o] : o === no && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(io)) {
                    i.push(s);
                    t.add(ir(s.slice(8)));
                } else {
                    s.startsWith(ro) ? d.push(s) : lo(s) !== null ? o.push(s) : s === eo ? a = n[s] : s === no && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = oo(e, r, h, t, l);
            l = l || e !== n;
            e = uo(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = oo(n, i, d, t, u);
            u = u || n !== e;
            n = uo(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && so.call(n, eo) && delete n[eo];
                if (e && so.call(e, eo)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[eo];
                }
                n.checked = a;
                const t = sa(null, "_chk", b, null, [ a ]);
                if (e && so.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ks(n, "q-e:input", t) || c;
                }
                c = Ks(n, "q-e:input", t) || c;
            } else if (f) {
                n && so.call(n, no) && delete n[no];
                if (e && so.call(e, no)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[no];
                }
                n.value = f;
                const t = sa(null, "_val", v, null, [ f ]);
                if (e && so.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ks(n, "q-e:input", t) || c;
                }
                c = Ks(n, "q-e:input", t) || c;
            }
        }
        if (n && so.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && so.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Gs(t, n, e, s, o, r, c || !0, i);
};

const ao = (t, n, e, s) => yo(t, n, s);

const ho = (t, n, e, s, o) => yo(t, {
    ...e,
    ...n
}, o);

const po = (t, n, e, s, o, r) => yo(t, {
    ...e,
    ...n,
    children: s
}, r);

const $o = t => t.children;

const yo = (t, n, e, s, o) => fo(t, n, null, null, 0, e, o);

const mo = yo;

const wo = yo;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return fo(t, n, null, s.children, 0, o);
}

const vo = t => t.children;

const bo = (t, n) => new Gs($o, null, null, t.children, 0, n);

const _o = t => co($o, null, {
    [ci]: ""
}, t.children, 0, t.name ?? "");

const go = Symbol();

const Eo = () => null;

const So = () => null;

const ko = t => t.children;

const Ro = (t, n) => yo(bo, {
    children: yo(Po, t)
}, n);

const Po = () => null;

let To = null;

let qo = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    qo || (qo = t.setAttributeNS);
                    qo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            To || (To = t.setAttribute);
            To.call(t, n, e);
        })(t, n, e);
    }
}

const Ao = Object.prototype.hasOwnProperty;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Mo = (t, n = [], e = {}) => {
    let s = null;
    const o = t[ls];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[us];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return m(new Gs(null, r, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && Ao.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Js) {
            return Ff(n, t, ":", e);
        }
    }
    return ws(n, "name") || "";
}

class xo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Io {
    target;
    constructor(t) {
        this.target = t;
    }
}

class No {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Co {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Oo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const jo = t => new xo(t);

const Lo = t => new Io(t);

const Fo = (t, n) => new No(t, n);

const Do = (t, n, e) => new Co(t, n, e);

const Xo = (t, n, e, s = null, o = !1) => new Oo(t, n, e, s, o);

const Wo = () => {
    const t = Nf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Oi);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Oi, s);
    }
    let o = t.$.getHostProp(e, ji);
    o === null && (o = 0);
    t.$.setHostProp(e, ji, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Vo = t => {
    const n = Je(t) && !va(t) ? qe(void 0, t) : t;
    return Fs(n);
};

const Uo = t => zo(Vo, t);

const zo = (t, ...n) => {
    const {val: e, set: s} = Wo();
    if (e != null) {
        return e;
    }
    t = Je(t) && !va(t) ? Of(t, ...n) : t;
    return s(t);
};

const Bo = () => ({
    pending: Fs(0),
    version: Fs(0)
});

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = q(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function P(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, Ri);
}

function T(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    gl(t, Ui, null);
}

function q(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return _l(t, Ui, null) || null;
    }(n) || P(t, n);
}

function A(t, n) {
    __EXPERIMENTAL__.suspense && gl(t, Ui, n);
}

function M(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    A(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        M(t, o, P(t, o) || e);
    }
}

const Qo = t => {
    if (t.cn) {
        try {
            t.cn();
        } catch (t) {
            Fe(t);
        }
        t.cn = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const n = Ee(s);
        return Tf(n, () => x(t, e, s, Cf(e, s, n)));
    }
    const r = o.$;
    const i = o.m;
    kl(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = _l(i, Li, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = _l(i, Fi, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return Ae(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Ee(n);
    return Tf(e, () => {
        const s = Cf(t, n, e);
        typeof this === "string" && ta(na(s.$, this));
        const o = Zf[0];
        return x(o, t, n, s);
    });
}

function N(t) {
    return t.k === t.R ? t.T : null;
}

function C(t) {
    return t.q || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const Ho = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, r) {
    gl(n, e, r);
    mn(t, Xo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        M: n,
        N: e,
        O: s,
        j: [],
        L: [],
        D: [],
        k: null,
        q: null,
        X: null,
        T: null,
        R: null,
        W: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: 0,
        G: 0,
        K: !0,
        Z: !1,
        tt: {
            nt: new Ys({
                O: s,
                et: !0
            }),
            it: new Ys({
                O: s,
                et: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const r = t ?? L(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.M = e;
        t.N = s;
        t.O = o;
        t.tt.nt.data.O = o;
        t.tt.it.data.O = o;
        t.L.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Jo = (t, n, e, s, o, r, i) => D(F(i, t, n, o, r), e, s);

const Yo = (t, n, e, s, o, r, i, c, l = !1, u) => D(F(u, t, n, i, c), e, s, o, r, l);

function D(t, n, e, s = Yl(e), o = null, r = !1) {
    X(t, n, e, s, o, r);
    const i = G(t);
    if (Ji(i)) {
        return i.finally(() => {
            K(t);
        });
    }
    K(t);
}

function X(t, n, e, s = Yl(e), o = null, r = !1) {
    const i = t.Z;
    t.Z = r || i;
    t.k = e;
    t.X = null;
    t.q = s;
    t.T = o;
    t.R = e;
    B(t, n, !0);
    try {
        if (t.k.flags & 32) {
            return;
        }
        for (;t.j.length; ) {
            for (;t.Y < t.G; ) {
                if (typeof t.J === "string") {
                    mt(t, t.J);
                } else if (typeof t.J === "number") {
                    mt(t, t.J + "");
                } else if (t.J && typeof t.J === "object") {
                    if (Zs(t.J)) {
                        const n = t.J.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.J, n);
                            const e = t.J.constProps && Ho.call(t.J.constProps, Bi) || Ho.call(t.J.varProps, Bi);
                            e ? t.X || Z(t, !1) : U(t, t.J.children, !0);
                        } else if (typeof n === "function") {
                            if (n === vo) {
                                nt(t);
                                dt(t, "F", t.J.key);
                                U(t, t.J.children, !0);
                            } else if (n === _o) {
                                nt(t);
                                J(t) || U(t, t.J.children, !0);
                            } else if (n === bt) {
                                H(t);
                                U(t, t.J.children, !0, !0);
                            } else if (n === So) {
                                tt(t);
                            } else if (n === Eo) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.J)) {
                        U(t, t.J, !1);
                    } else if (qu(t.J)) {
                        dt(t, "S", null);
                        const n = t.J instanceof Js ? t.J.rt() : t.J;
                        const e = t.q?.[Vr]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Js && (s = xt(e, n));
                        if (!s) {
                            const e = t.X || t.q;
                            U(t, W(t, () => Ff(n, e, ".", t.$)), !0);
                        }
                    } else if (Ji(t.J)) {
                        dt(t, "A", null);
                        t.L.push(t.J, t.X || t.q);
                    }
                } else {
                    t.J === go || mt(t, "");
                }
                V(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.Z = i;
    }
}

function W(t, e) {
    try {
        return e();
    } catch (s) {
        if (Ji(s)) {
            const o = s.then(() => n(e));
            t.L.push(o, t.X || t.q);
            return null;
        }
        throw s;
    }
}

function V(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.Y++;
    if (t.Y < t.G) {
        t.J = t.H[t.Y];
    } else if (t.j.length > 0 && t.j[t.j.length - 1] === !1) {
        return z(t);
    }
    t.X !== null ? t.X = null : t.q = O(t, t.q);
}

function U(t, n, e, s = !1) {
    if (!s && (n == null || e && Qe(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = !s && t.Z || !!t.X || !Yl(t.q);
        t.Z = n;
        t.B = null;
        t.W = null;
        t.U = null;
        t.k = t.X || t.q;
        t.q = Yl(t.k);
        t.X = null;
    }
    t.K = !1;
}

function z(t) {
    const n = t.j.pop();
    if (n) {
        t.Z = t.j.pop();
        t.B = t.j.pop();
        t.W = t.j.pop();
        t.U = t.j.pop();
        t.X = t.j.pop();
        t.q = t.j.pop();
        t.k = t.j.pop();
    }
    t.J = t.j.pop();
    t.G = t.j.pop();
    t.Y = t.j.pop();
    t.H = t.j.pop();
    V(t);
}

function B(t, n, e) {
    t.j.push(t.H, t.Y, t.G, t.J);
    e && t.j.push(t.k, t.q, t.X, t.U, t.W, t.B, t.Z);
    t.j.push(e);
    if (Array.isArray(n)) {
        t.Y = 0;
        t.G = n.length;
        t.H = n;
        t.J = t.G > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.Y = 0;
        t.J = null;
        t.H = null;
        t.G = 0;
    } else {
        t.Y = 0;
        t.J = n;
        t.H = null;
        t.G = 1;
    }
}

function Q(t) {
    if (t.X) {
        return C(t);
    }
    return O(t, t.q) || N(t);
}

function H(t) {
    const n = t.J;
    const e = n.key;
    t.q = _l(t.k, e, n => ql(t.$.rootVNode, n));
    t.q = t.q && t.q.flags & 32 ? null : t.q;
    if (t.q == null) {
        t.X = dl();
        gl(t.X, ui, e);
        t.X.slotParent = t.k;
        gl(t.k, e, t.X);
    }
}

function J(t) {
    const n = t.J;
    const e = Eu(t.k);
    const s = k(e, n, t.$);
    const o = ws(n, Ri) || null;
    const r = e ? _l(e, s, null) : null;
    if (r == null) {
        t.X = dl();
        gl(t.X, ui, s);
        gl(t.X, Ri, o);
        M(t.$, t.X, o);
        e && gl(e, s, t.X);
        Wl(t.M, t.k, t.X, Q(t));
        return !1;
    }
    if (r === t.q) {} else {
        const n = r.parent;
        t.X = r;
        gl(t.X, ui, s);
        gl(t.X, Ri, o);
        M(t.$, t.X, o);
        e && gl(e, s, t.X);
        Xl(t.M, t.X);
        Wl(t.M, t.k, t.X, Q(t));
        n && $l(n) && !n.firstChild && Ql(n) === Pi && zl(t.M, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.B;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Et(t.$, t.M, e, t.N);
            zl(t.M, t.k, e, !0);
        }
        n.clear();
        t.B = null;
    }
    t.q = null;
}

function G(t) {
    for (;t.L.length; ) {
        const n = t.L.shift();
        const e = t.L.shift();
        if (Ji(n)) {
            return n.then(n => {
                X(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        X(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.M = null;
    t.N = null;
}

function Z(t, n = !0) {
    const e = t.q && Yl(t.q);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Et(t.$, t.M, s, t.N);
            s = s.nextSibling;
        }
        Bl(t.M, t.q, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.q !== null && t.q !== n) {
        for (;t.q && t.q !== n; ) {
            const n = t.q;
            t.q = O(t, t.q);
            if (t.k === n.parent) {
                Et(t.$, t.M, n, t.N);
                zl(t.M, t.k, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.q !== null && wl(t.q)) {
        const n = t.q;
        t.q = O(t, t.q);
        zl(t.M, t.k, n, !0);
    }
}

function et(t, n, e) {
    if (qu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Ye(15, [ e ]);
}

function it(t, e, s, o, r) {
    return n(() => Ff(o, e, s, t, r));
}

function rt(t, n, e, s, o) {
    const r = t.O;
    const c = s.then(t => E(n, e, i(e, t, r), o));
    t.D.push(c);
}

function st(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Si, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, s) {
    const r = function c(t, n) {
        const e = Ul(t.k, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.X = fl(i, n);
        t.X.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.X;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (er(n)) {
                ut(n, o, r, l, t);
                continue;
            }
            if (n === "ref" && et(o, r, s)) {
                continue;
            }
            qu(o) && (o = it(t.$, t.X, n, o, t.tt.nt));
            if (Ji(o)) {
                rt(t, r, n, o, u);
                continue;
            }
            if (n === Bi) {
                st(r, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(r, o)) {
                continue;
            }
            E(r, n, i(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.X.key = a);
    if (t.O) {
        const e = Ho.call(n.varProps, "class") || n.constProps && Ho.call(n.constProps, "class");
        e || r.setAttribute("class", t.O);
    }
    Ol(t.M, t.k, t.X, C(t));
}

function ut(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && El(o.M, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function ct(t, n, e) {
    if (t.Z) {
        lt(t, n, e, null);
    } else {
        const s = t.q && $l(t.q);
        const o = s && e === Ql(t.q);
        const r = n.key;
        const i = s && t.q.key;
        if (o && r === i) {
            at(t, e, r);
        } else {
            const s = ft(e, r);
            ht(t, e, r, s, t.k) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.X || t.q;
    s && function r(t, n, e, s) {
        t.Z || kl(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !Ho.call(o, i) ? i.toLowerCase() : i;
            if (o && Ho.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    gl(n, l, null);
                    gl(n, i, e);
                }
                Pt(c, e) || Go(t, n, i, c, s);
            } else {
                c != null && Go(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                Ho.call(e, r) || r.charAt(0) === ":" || er(r) || Go(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Go = (t, n, e, s, o) => {
    if (er(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === Li || e === Fi) {
        gl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const i = n[Vr]?.get(e);
    if (qu(s)) {
        const o = s instanceof Js ? s.rt() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Rn(t.$, i);
        const r = n;
        s = it(t.$, r, e, o, t.tt.it);
    } else {
        i && Rn(t.$, i);
    }
    if (Ji(s)) {
        const o = n;
        const i = s.then(n => {
            j(t.M, o, e, n, t.O, r);
        });
        t.D.push(i);
        return;
    }
    j(t.M, n, e, s, t.O, r);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.B?.has(s)) {
        t.B.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, r) {
    t.X = function i(t, n, e) {
        let s = null;
        if (t.W === null) {
            const o = t.q;
            if (o) {
                const s = $l(o) ? Ql(o) : null;
                const r = wt(o) || vt(o, t.$._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.W = new Map;
            t.U = [];
            const r = N(t);
            let i = t.q;
            for (;i && i !== r; ) {
                const o = $l(i) ? Ql(i) : null;
                const r = wt(i) || vt(i, t.$._);
                s === null && r == e && o == n ? s = i : r === null ? t.U.push(o, i) : t.W.set(ft(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.U.length; e += 2) {
                if (t.U[e] === n) {
                    s = t.U[e + 1];
                    t.U.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const r = t.W.get(o);
            if (r) {
                s = r;
                t.W.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.q) {
                    const n = $l(t.q) ? Ql(t.q) : null;
                    const e = wt(t.q) || vt(t.q, t.$._);
                    if (e != null) {
                        const s = ft(n, e);
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                        t.W?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.q;
            for (;s && s !== n && s !== e; ) {
                const n = $l(s) ? Ql(s) : null;
                const e = wt(s) || vt(s, t.$._);
                if (e != null) {
                    const o = ft(n, e);
                    t.B ||= new Map;
                    t.B.set(o, s);
                    t.W?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.X) {
        s || Wl(t.M, o, t.X, C(t));
        t.q = t.X;
        t.X = null;
        return !1;
    }
    if (s != null) {
        const n = t.B?.get(s) || null;
        if (n) {
            t.B.delete(s);
            if (r && t.q) {
                const n = wt(t.q) || vt(t.q, t.$._);
                if (n != null) {
                    const e = $l(t.q) ? Ql(t.q) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.B ||= new Map;
                        t.B.set(s, t.q);
                    }
                }
            }
            n !== t.q && Wl(t.M, o, n, C(t));
            t.q = n;
            t.X = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.q);
    const r = t.q && vl(t.q);
    const i = r && o === e && (!s || !!e);
    if (i) {
        at(t, null, o);
        return;
    }
    if (e === null || t.Z) {
        jl(t.M, t.k, t.X = dl(), Q(t));
        t.X.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.k, !0)) {
        jl(t.M, t.k, t.X = dl(), Q(t));
        t.X.key = e;
    }
}

function pt(t, n) {
    const e = n[wa];
    let s = t.X || t.q;
    const o = t.J;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.st;
        const l = vt(s, t.$._);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.X;
                r = !0;
            }
        } else {
            if (ht(t, null, u, u, t.k)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.X || t.q;
        }
        if (s) {
            const e = _l(s, Ci, t.$._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[ls], e[ls], e[fs], s, !1);
                        o ||= t;
                        const r = _t(n[us], e[us], e[fs], s, !0);
                        o ||= r;
                        e[cs] = n[cs];
                    } else if (n) {
                        gl(t, Ci, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.X;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                gl(s, si, i);
                s.flags &= -33;
                yn(t.$, s, 4, t.N);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Gs(bt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            We(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Zs(n) && ws(n, ui) || "") + "";
                const i = Xe(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            U(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = wt(s);
        const i = e === r;
        const c = vt(s, t.$._);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.X;
        } else if (i) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.k) && yt(t);
            s = t.X || t.q;
        }
        if (s) {
            let e = s;
            for (;e && (!vl(e) || _l(e, si, null) === null); ) {
                e = e.parent || Eu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[os] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            yn(t.$, s, 8, t.N);
        }
    }
}

function $t(t, n, e, s) {
    n && kn(t.$, n);
    jl(t.M, t.k, t.X = dl(), Q(t));
    const o = t.J;
    gl(t.X, si, e);
    gl(t.X, Ci, s);
    t.X.key = o.key;
}

function yt(t) {
    jl(t.M, t.k, t.X = dl(), Q(t));
    const n = t.J;
    gl(t.X, Ci, n.props);
    n.key && (t.X.key = n.key);
}

function mt(t, n) {
    if (t.q !== null) {
        const e = _u(t.q);
        if (e === 3) {
            if (n !== Hl(t.q)) {
                Jl(t.M, t.q, n);
                return;
            }
            return;
        }
    }
    Ol(t.M, t.k, t.X = hl(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || wl(t)) {
        return null;
    }
    return t.key;
}

function vt(t, n) {
    if (t == null || wl(t)) {
        return null;
    }
    const e = _l(t, si, n);
    return e ? e.st : null;
}

function bt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === mi) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (!n || !Pt(i, c) && !Tt(i, c)) {
                if (s === "class") {
                    if (At(i, c)) {
                        continue;
                    }
                } else if (s === "style" && qt(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = ms(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === mi) {
                continue;
            }
            if ((!t || !Ho.call(t, s)) && o) {
                delete n[s];
                const t = ms(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return Cr(t);
}

function Et(t, n, e, s = null) {
    let o = e;
    const r = s && dn(s) ? y(s) : null;
    if (wl(e)) {
        Rt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && dn(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            kn(t, o);
            Rt(o);
            const r = c & 2 && _l(o, si, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Oi);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Be(r)) {
                            const n = Pu(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                yn(t, o, 128, s);
                                continue;
                            }
                            (r instanceof Ms || r instanceof Js) && (r.h & 4 || kn(t, r));
                            (n || r instanceof Ms && (r.h & 512 || r.ot)) && Qo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? ql(t.rootVNode, e) : e;
                                let c = Yl(o);
                                for (;c; ) {
                                    Et(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = bl(o);
            if (i) {
                if (o === e) {
                    const n = Yl(o);
                    if (n) {
                        bn(n);
                        return;
                    }
                    St(t, o);
                }
            } else {
                const t = Yl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function St(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, ui);
    e != null && t.getHostProp(n.slotParent, e) === n && gl(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Ql(s) === Pi) {
            St(t, e);
            zl(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Js && n instanceof Js && Mt(n, t);
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    if (qu(t) && qu(n)) {
        const e = t instanceof Js ? t.rt() : t;
        const s = n instanceof Js ? n.rt() : n;
        return Of(() => e.value === s.value);
    }
    return !1;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return fr(t) === fr(n);
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return ur(t) === ur(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.lt === t.lt && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ut, t.ut);
}

function xt(t, n) {
    if (!(n instanceof Js)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Js && Mt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Ko = (t, n, e, s, o) => {
    const r = Me(t.en, n, t);
    if (e) {
        r.sn = w(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, si));
    if (Ke(s)) {
        o = o || t.getHostProp(n, Ci) || ps;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (va(s)) {
        const t = s;
        i = () => Ae(r, t, [ o || ps, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => Ae(r, t, [ o || ps ]);
    }
    const l = Ce;
    const u = (e = 0) => Yi(() => {
        if (!c) {
            t.setHostProp(n, ji, null);
            t.setHostProp(n, Wi, null);
        }
        e > 0 && pl(n) && kn(t, n);
        return Gi(i(o), t => Gi(r.ln, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Hi) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Xi);
        if (o) {
            return function r(t, n, e) {
                const s = Ot(n);
                let o = n;
                const r = "q-e:qvisible";
                return Gi(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = Lt();
                                    const n = Ce;
                                    n && t.ct(i) || (o = jt(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                Nt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (Ji(t) && e < Hi) {
            return t.then(() => u(++e));
        }
        if (e >= Hi) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Nt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = sr(n);
    c && Ct(t, f, "capture");
    l && Ct(t, f, "preventdefault");
    u && Ct(t, f, "stoppropagation");
}

function Ct(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === ps && (t.varProps = {});
    t.varProps[s] = !0;
}

function Ot(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Zs(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Qe(t)) {
            n.push(...t);
        } else {
            if (Ji(t)) {
                return Gi(t, t => Ot(t));
            }
            if (qu(t)) {
                return Ot(t.untrackedValue);
            }
        }
    }
    return null;
}

function jt(t, n) {
    if (Zs(t)) {
        if (t.type !== vo && !va(t.type)) {
            return co(vo, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : Qe(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return co(vo, null, null, [ t, n ], 0, null);
    }
    if (Qe(t) && t.length > 0) {
        jt(t[0], n);
        return t;
    }
    return t;
}

function Lt() {
    return new Gs("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ft(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Dt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Ft(t[c], c, r, s);
    }
    return i;
}

function Xt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Wt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Yl(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Yo(c, n, Dt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Bl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Yo(c, n, Dt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Bl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            zl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return Yo(c, n, Dt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const m = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function _(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            zl(n, e, s, !0);
        }
    }
    const S = new Int32Array(m);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(m);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let M = d;
    let A = w;
    const I = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                A = g[S[t]];
                M--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Wl(n, e, t, A);
                A = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = Yo(c, n, Dt(o, a, null, i, l, M), e, A, A, s, null, !0, f);
            return Gi(d, () => {
                const t = Xt(e, A, u);
                A = t;
                M = l - 1;
                return I();
            });
        }
    };
    return I();
}

function Vt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Oi);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Ru) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = ku(s, n, t);
                Ji(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Ut(t, n) {
    const e = t.props ||= {};
    e[is] = n;
}

function zt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[rs] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[rs] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Nl(n, document, r, e);
    const u = $l(r) && i || r;
    const f = u === r ? null : c;
    Ol(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Bt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[is];
    }(t);
    if (!r) {
        return;
    }
    Ut(t, null);
    qu(r) && (r = r.value);
    return Jo(n, e, r, o, s, null);
}

function Qt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, si);
    if (r && !r.resolved) {
        return r.resolve();
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Ci) || null;
    return Jt(n, o, o, r, i, e, s);
}

function Ht(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[os] || null;
        e && delete n[os];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Jt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Jt(t, e, s, o, r, i, c) {
    const l = Yi(() => Ko(t, e, s, o, r), s => {
        const o = t.getHostProp(e, $i);
        return n(() => Jo(t, i, s, e, c, nr(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (Ji(l)) {
        return l;
    }
    return;
}

function Yt(t, n, e, s, o, r = null) {
    n.push(Xo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Gt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[es] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        qu(e) && (e = e.value);
        const r = s.isConst;
        Yt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[es];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Oi);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Ru && n.h & 16) {
            n.h &= -17;
            const t = n;
            Qo(t);
        }
    }
}

function Zt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, ss);
    if (!s) {
        return;
    }
    const o = s.ft;
    const r = xe();
    r.$ = e;
    return Gi(n(() => qe.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Nu(e, s, o);
        }
    });
}

function tn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const r = n.getHostProp(o, Ci) || null;
    if (!r) {
        return;
    }
    let i = vs(r, "items");
    qu(i) && (i = Of(i));
    const c = vs(r, "key$");
    const l = vs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Wt(n, e, o, s, i, u, f);
    }
    return Gi(c.resolve(), t => Gi(l.resolve(), r => Wt(n, e, o, s, i, t, r)));
}

let Zo = null;

const tl = (t, n, e) => {
    Zo || (Zo = t.insertBefore);
    Zo.call(t, n, e);
};

function nn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                tl(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                tl(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof Co) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                r();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                r();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            tl(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof xo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && r();
            l.target.remove();
            continue;
        }
        if (l instanceof Io) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && r();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof No) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Oo) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? i(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (nl(t, e)) {
                t[e] = el(o);
            } else if (e === Bi) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(Si, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : E(t, e, o, l.isSvg);
            }
        }
    }
    r();
}

const nl = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const el = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const il = (t => () => queueMicrotask(t))(sn);

const sl = hr(sn);

let ol = !1;

function en() {
    if (!ol) {
        ol = !0;
        il();
    }
}

function rn() {
    if (!ol) {
        ol = !0;
        sl();
    }
}

function sn() {
    ol = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (on(e, n)) {
            rn();
            return;
        }
    }
}

function on(t, n) {
    const e = Ce;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        ln(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(r, s, fn(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(r, s, fn(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Vt(l, r, s);
            } else if (l.dirty & 2) {
                e = Bt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Qt(l, r, i, t);
            } else if (l.dirty & 8) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 256) {
                e = tn(l, r, i, t);
            } else if (l.dirty & 16) {
                Gt(l, i);
            } else if (l.dirty & 32) {
                e = Zt(l, r);
            } else if (l.dirty & 64) {
                const n = cn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && zt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && Ji(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                en();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    ln(r, t, s, e);
}

function ln(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                nn(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    ku(s, t, s.ht);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                un(t);
            });
            return;
        }
        un(t);
    }
}

function un(t) {
    t.dt();
}

function cn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = fn(o[0], s, t);
    p(t, n, i);
    return i;
}

function fn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && an(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return fn(s, n, e);
}

function an(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(Ri in n.props) || !t.getHostProp(n, Ri)) {
        return !1;
    }
    dn(n) || hn(t, n, 0);
    return !0;
}

function hn(t, n, e) {
    if (dn(n)) {
        en();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        ns.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    en();
    return r;
}

function dn(t) {
    return (t.flags & 256) !== 0;
}

function pn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(es);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                qu(e) && (e = e.value);
                const r = i(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && Zt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Oi);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Ru) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = ku(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        Ji(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, Ci) || null;
            if (!s) {
                return;
            }
            let o = vs(s, "items");
            qu(o) && (o = Of(o));
            const r = await vs(s, "key$").resolve();
            const i = await vs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const ll = [];

function $n(t) {
    for (let n = 0; n < ll.length; n++) {
        const e = ll[n];
        const s = ll[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function yn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return Ce;
    }()) {
        const e = pn(t, n);
        Ji(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            ll.push(n);
            let o = P(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 1023;
                const i = dn(r);
                __EXPERIMENTAL__.suspense && (o ||= P(t, r) || (e ? q(t, r) : null));
                if (r === s || e) {
                    A(n, o);
                    $n(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    ll.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                ll.push(r);
                r = r.slotParent || r.parent;
            }
            ll.length = 0;
            ((t, ...n) => {
                const e = De(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        A(n, P(t, n) || q(t, c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (dn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        dn(n) ? A(n, P(t, n)) : function l(t, n) {
            ll.push(n);
            let e = __EXPERIMENTAL__.suspense ? P(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = dn(s);
                __EXPERIMENTAL__.suspense && (e ||= P(t, s) || (o ? q(t, s) : null));
                if (o) {
                    A(n, e);
                    $n(s);
                    ll.length = 0;
                    return !0;
                }
                ll.push(s);
                s = s.slotParent || s.parent;
            }
            A(n, e);
            ll.length = 0;
            return !1;
        }(t, n) || hn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const ul = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const cl = t => {
    let n = null;
    return e => {
        n || (n = ul(e, t));
        return n.call(e);
    };
};

const fl = (t, n, e = null) => {
    const s = new Gr(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const al = t => {
    const n = new Gr(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const hl = (t, n) => {
    const e = new Kr(-4084, null, null, null, null, t, n);
    return e;
};

const dl = () => {
    const t = new Yr(null, -4094, null, null, null, null, null, null);
    return t;
};

const pl = t => t instanceof Jr;

const $l = t => (t.flags & 1) === 1;

const yl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const ml = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const wl = t => (t.flags & 4) === 4;

const vl = t => (t.flags & 2) === 2;

const bl = t => {
    const n = t.flags;
    return (n & 2) === 2 && _l(t, ui, null) !== null;
};

const ud = t => t;

const _l = (t, n, e) => {
    if ($l(t) || vl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const gl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const El = (t, n, e, s, o = null) => {
    if ($l(n)) {
        gl(n, e, s);
        mn(t, Xo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Sl = t => {
    if (t.key) {
        return;
    }
    const n = nu(t.node, zi);
    n && (t.key = n);
};

const kl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (er(c)) {
                wn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== zi && c) {
                if (c.startsWith(Si)) {
                    const t = i.value;
                    t === "html" ? gl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && gl(e, "value", s.value);
                } else {
                    const t = i.value;
                    gl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        _l(e, Li, null) === null && _l(e, Fi, null) === null || (n.flags |= 64);
    }
};

const Rl = t => {
    if (t._t === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ke(n)) {
            return n;
        }
    }
    return t;
};

function wn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Rl(Ln(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function vn(t, n, e) {
    let s = Yl(n);
    for (;s; ) {
        if (wl(s)) {
            Tl(t, s);
            e(s, n);
        } else {
            $l(s) ? e(s, n) : vn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function bn(t) {
    let n = t;
    if (wl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Yl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Pl = (t, n, e) => {
    let s = t;
    for (;e && s && vl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !vl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !vl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (wl(t) && e && $l(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && mu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Tl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Vl(n, !0);
        const o = e.node;
        const r = au(s);
        let i = Pl(n, !1, !0);
        const c = Pl(n, !0, !0);
        const l = o || (c && $l(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && wl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, Do(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Pl(i, !1, !0);
        }
        i = n;
        for (;i && wl(i); ) {
            const n = Pl(i, !0, !0);
            const e = !n || !wl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Fo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, Do(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const ql = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = al(i);
            Sl(e);
            t.vNode = e;
            return e;
        }
    }
    if (pl(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || al(i);
            Sl(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = xl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Il(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = Al(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const Al = (t, n) => {
    let e = Yl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Ml = [];

const xl = (t, n) => {
    let e = Yl(t);
    for (;e && (!(e instanceof Gr) || e.node !== n); ) {
        if (vl(e)) {
            const t = e.nextSibling;
            const n = Yl(e);
            if (n) {
                t && Ml.push(t);
                e = n;
            } else {
                e = t || (Ml.length ? Ml.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Ml.pop();
        }
    }
    for (;Ml.length; ) {
        Ml.pop();
    }
    return e;
};

const Il = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Nl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = fl(o, "errored-host");
    if (yl(e)) {
        Wl(t, r, e, null);
    } else {
        const n = [];
        vn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Wl(t, r, n[e], null);
        }
    }
    return r;
};

const Cl = nn;

const Ol = (t, n, e, s) => {
    const o = $l(n);
    o && Gl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Dl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Vl(n, !1);
    l && !c && mn(t, Do(i, l, Ll(t, n, s)?.node ?? null));
    Fl(n, e, s);
    c && (e.flags |= 32);
};

const jl = (t, n, e, r) => {
    const i = $l(n);
    i && Gl(n);
    const c = e.parent;
    if (e === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Dl(t, c, n, e);
    const l = n.flags & 32;
    const u = !i && n.flags & 2048 ? n.props?.[oi] : null;
    const f = u ? null : i ? n : Ul(n, !1);
    const a = u || f?.node;
    const h = Ll(t, n, r);
    const d = h?.node ?? null;
    const p = bl(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Ul(n, !1);
        const c = Ll(t, n, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(i, e);
        vn(t, e, n => {
            if (wl(n)) {
                mn(t, Do(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if ($l(c)) {
                                e = c.node;
                                const t = Ql(c);
                                const l = c.parent;
                                const h = u == null ? n : l && Ul(l, !0);
                                if (h) {
                                    const t = o(h, Ql(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Yl(c);
                                a = s(e, t, r, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Zl(e)) {
                                    const t = Se(e);
                                    if (t) {
                                        const n = Yl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, i, l, u);
                    t && (n.node = t);
                }
                mn(t, Do(n.node, a, c));
            }
        });
    } else {
        a && !l && vn(t, e, n => {
            mn(t, Do(n.node, a, d));
        });
    }
    Fl(n, e, r);
    l && (e.flags |= 32);
};

const Ll = (t, n, e) => {
    let s = null;
    e == null ? vl(n) && (s = Pl(n, !0, !1)) : s = vl(e) ? Pl(e, !0, !0) : e;
    s && wl(s) && Tl(t, s);
    return s;
};

const Fl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Dl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && zl(t, n, s, !1);
};

const Xl = (t, n) => {
    let e = n;
    for (;e && vl(e); ) {
        e = e.lastChild;
    }
    e && wl(e) && (e.flags & 8) === 0 && Tl(t, e);
};

const Wl = (t, n, e, s) => {
    yl(e) ? Ol(t, n, e, s) : jl(t, n, e, s);
};

const Vl = (t, n) => {
    for (;t && !$l(t); ) {
        if (t.flags & 2048) {
            return t.props?.[oi];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Ul = (t, n) => {
    for (;t && !$l(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const zl = (t, n, e, s) => {
    wl(e) && Tl(t, e);
    if (s) {
        const s = _l(n, Bi, null) !== null;
        if (s) {
            return;
        }
        yl(e) ? mn(t, jo(e.node)) : vn(t, e, n => {
            mn(t, jo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Bl = (t, n, e, s = !0) => {
    const o = Vl(n, !0);
    if (o && s) {
        if (yl(n)) {
            mn(t, Lo(n.node));
        } else {
            const e = Ul(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, Lo(o)) : vn(t, n, n => {
                mn(t, jo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Ql = t => {
    const n = ud(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = fu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = cu(t);
            switch (n) {
              case Ai:
                return 512;

              case Mi:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Hl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Jl = (t, n, e) => {
    Tl(t, n);
    n.text = e;
    mn(t, Fo(n.node, e));
};

const Yl = t => {
    if (wl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && $l(t) && function e(t) {
        const n = t.getAttribute(od);
        if (n === null) {
            return !1;
        }
        const e = uu(t);
        return gu(e) && e.localName === "template" && e.getAttribute(ai) === n && su(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Gl(t));
    return n;
};

const Gl = n => {
    const e = ud(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && Zl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = uu(e);
            const o = au(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                Sl(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === ii && o.charCodeAt(1) === ii) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = hu(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = gu(t);
                            return !n || n && Sn(t);
                        };
                        let p = null;
                        du(e, ($, y, w, m, b, v) => {
                            if (wu($())) {
                                for (;d(o); ) {
                                    o = su(o);
                                    if (!o) {
                                        throw Ye(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;wu($()); ) {
                                    t *= 10;
                                    t += w() - 48;
                                }
                                for (;t--; ) {
                                    const n = al(o);
                                    Sl(n);
                                    u(n);
                                    o = su(o);
                                    for (;gu(o) && Sn(o); ) {
                                        o = su(o);
                                        if (!o && t > 0) {
                                            throw Ye(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                gl(n, $i, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                gl(n, si, y());
                            } else if ($() === 61) {
                                h || (h = Ee(s));
                                const t = y();
                                h.Bn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                gl(n, Ci, y());
                            } else if ($() === 64) {
                                n.key = v();
                            } else if ($() === 91) {
                                gl(n, Oi, y());
                            } else if ($() === 94) {
                                gl(n, ji, y());
                            } else if ($() === 96) {
                                h || (h = Ee(s));
                                gn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = Ee(s));
                                n.slotParent = ql(h.rootVNode, y());
                            } else if ($() === 93) {
                                gl(n, yi, y());
                            } else if ($() === 123) {
                                w();
                                u(dl());
                                bu.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === ii) {
                                const e = y();
                                const s = t(e);
                                const o = b + e.length + 1;
                                const r = m(o + 1) === ii;
                                let i;
                                if (r) {
                                    w();
                                    i = decodeURI(t(y()));
                                    w();
                                } else {
                                    i = t(y());
                                }
                                gl(n, s, i);
                            } else if ($() === 125) {
                                w();
                                n.lastChild = c;
                                r = bu.pop();
                                l = bu.pop();
                                c = bu.pop();
                                i = bu.pop();
                                n = bu.pop();
                            } else if ($() === 126) {
                                gl(n, ui, v());
                            } else {
                                for (;gu(o) && Sn(o); ) {
                                    o = su(o);
                                }
                                const t = o && eu(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;vu($()); ) {
                                    n += w() - 97;
                                    n *= 26;
                                }
                                n += w() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Kr(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Ee(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return hu(n, s, void 0);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Kl = null;

const Zl = t => {
    Kl || (Kl = t.hasAttribute);
    return Kl.call(t, Si);
};

let tu = null;

const nu = (t, n) => {
    tu || (tu = t.getAttribute);
    return tu.call(t, n);
};

const eu = cl("nodeType");

const iu = t => {
    const n = eu(t);
    return n === 3 || n === 1;
};

let ru = null;

const su = t => {
    ru || (ru = ul(t, "nextSibling"));
    lu || (lu = ul(t, "firstChild"));
    for (;t; ) {
        t = ru.call(t);
        if (t !== null) {
            const n = eu(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(gi)) {
                    return _n(t, bi, ru, lu);
                }
                if (t.nodeValue?.startsWith(_i)) {
                    return _n(t, [ bi, Ei ], ru, lu);
                }
                if (n?.startsWith(Si)) {
                    for (;t && (t = ru.call(t)) && (eu(t) !== 8 || !t.nodeValue?.startsWith(ki)); ) {}
                }
            }
        }
    }
    return t;
};

function _n(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = ou(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const ou = cl("parentNode");

let lu = null;

const uu = t => {
    lu || (lu = ul(t, "firstChild"));
    t = t && lu.call(t);
    if (t && eu(t) === 8) {
        ru || (ru = ul(t, "nextSibling"));
        if (t.nodeValue?.startsWith(gi)) {
            return _n(t, bi, ru, lu);
        }
    }
    for (;t && !iu(t); ) {
        t = su(t);
    }
    return t;
};

const cu = cl("namespaceURI");

const fu = cl("nodeName");

const au = cl("ownerDocument");

const hu = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;gu(i) && Sn(i); ) {
            i = su(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = eu(i);
        let e = null;
        if (n === 3) {
            e = hl(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = al(i);
            Sl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = su(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        du(e, (e, s) => {
            if (e() === 61) {
                n || (n = Ee(t.node));
                const e = s();
                n.Bn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Ee(t.node));
                gn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function gn(t, n, e) {
    if (t[Vr]) {
        const s = t[Vr];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, Vr, {
            get() {
                const s = e._(n);
                t[Vr] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Vr, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const du = (n, e) => {
    let s = 0;
    let o = 0;
    let r = 0;
    const i = t => t < n.length ? n.charCodeAt(t) : 0;
    const c = () => r !== 0 ? r : r = i(s);
    const l = () => {
        o = c();
        r = 0;
        s++;
        return o;
    };
    const u = () => {
        l();
        const t = s;
        for (;c() <= 58 && r !== 0 || r === 92 || r === 95 || r >= 65 && r <= 90 || r >= 97 && r <= 122; ) {
            l();
        }
        return n.substring(t, s);
    };
    const f = () => {
        if (i(s + 1) !== ii) {
            return u();
        }
        l();
        const n = decodeURIComponent(t(u()));
        l();
        return n;
    };
    for (;c() !== 0; ) {
        e(c, u, l, i, s, f);
    }
};

const pu = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        kl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(zi) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const $u = (t, n) => {
    let e = yu(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = yu(e);
    }
    return !1;
};

const yu = t => t.parent || t.slotParent;

const mu = t => {
    if (t === null || vl(t)) {
        return null;
    }
    return t.node;
};

function En(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if ($l(e)) {
                        const t = ke(e.node);
                        if (!t) {
                            return null;
                        }
                        return Se(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (wl(i)) {
            c.push(Mn(Hl(i)));
        } else if (vl(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = pu(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Ze && e !== "__scopedStyleIdPrefix__") {
                        const t = _l(i, e, null);
                        s.push(" " + e + "=" + Mn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (ti[_l(i, Ze, null) || "V"] || ti.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Yl(i);
            u && c.push("  " + En.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if ($l(i)) {
            const s = Ql(i);
            const l = [];
            dn(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? pu(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = _l(i, n, null);
                l.push(" " + n + "=" + Mn(e));
            }
            const f = mu(i);
            if (f) {
                const t = au(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Mn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Mn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (ml(i) || e) {
                const e = Yl(i);
                e && c.push("  " + En.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const wu = t => 48 <= t && t <= 57;

const vu = t => 97 <= t && t <= 122;

function Sn(t) {
    return !t.hasAttribute(zi) || t.nodeName === "STYLE" && (t.hasAttribute($i) || t.hasAttribute(hi));
}

const bu = [];

const _u = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Ye(26, [ n ]);
};

const gu = t => t && typeof t == "object" && eu(t) === 1;

const Eu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!vl(t) || _l(t, si, null) === null); ) {
            const e = t.slotParent;
            const s = vl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function kn(t, n) {
    pl(n) && $l(n) && Gl(n);
    const e = n[Vr];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Rn(t, n);
    }
    e.clear();
}

function Rn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof qs) {
            Pn(t, s, n);
            s instanceof Ms && Tn(s, n);
        } else if (gs(s)) {
            const t = s[fs];
            qn(t, n);
        } else if (t.$t.has(s)) {
            const e = t.$t.get(s);
            const o = Du(e);
            qn(o, n);
        }
    }
    e.clear();
}

function Pn(t, n, e) {
    const s = n.ft;
    s && s.has(e) && s.delete(e);
    if (n instanceof Js && !s?.size) {
        n.m = void 0;
        kn(t, n);
    }
}

function Tn(t, n) {
    const e = t.yt;
    e && e.has(n) && e.delete(n);
    const s = t.wt;
    s && s.has(n) && s.delete(n);
    t.vt();
}

function qn(t, n) {
    const e = t?.ft;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Su = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Wo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Ru(6 | i, r, o.m, t, null);
    s(c);
    const l = o.$;
    const {ln: u} = o;
    const f = Gi(u, () => ku(c, l, o.m));
    Ji(f) && (o.ln = f);
};

const ku = (t, n, e) => {
    const s = t.Qn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = Gi(((t, n) => {
        const e = t.Hn;
        if (e) {
            return e;
        }
        const s = t.cn;
        if (!s) {
            return;
        }
        t.cn = null;
        try {
            const e = s();
            if (Ji(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Hn === s && (t.Hn = void 0);
                });
                t.Hn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = xe(n.en, e, "qTask");
        s.$ = n;
        const i = t.bt.getFn(s, () => kn(n, t));
        const c = Ts(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.cn = () => {
                            t.cn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    Ji(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Yi(() => i(u), l, s => {
            if (Ji(s)) {
                return s.then(() => {
                    t.Qn === r && (t.Qn = null);
                    return ku(t, n, e);
                });
            }
            o(s);
        });
    });
    if (Ji(i)) {
        r = i.finally(() => {
            t.Qn === r && (t.Qn = null);
        });
        t.Qn = r;
        return r;
    }
    return i;
};

class Ru extends Ur {
    h;
    Nt;
    ht;
    bt;
    cn;
    Hn;
    Qn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Nt = n;
        this.ht = e;
        this.bt = s;
        this.cn = o;
    }
}

const Pu = t => t instanceof Ru;

function An(t, n) {
    const e = Ee(n);
    return Tf(e, () => {
        typeof this === "string" && ta(na(e, this));
        const t = Zf[0];
        t.h |= 4;
        yn(e, t.ht, 1);
    });
}

const Tu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const qu = t => t instanceof qs;

const Au = (t, n) => {
    t.add(n);
};

const Mu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const xu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Pu(e) ? o = e.bt : e instanceof Ms ? o = e.Ot : s === ":" && (o = n.getHostProp(e, si));
        o && n.serializationCtx.It.add(o);
    }
};

const Iu = (t, n) => {
    if (t && (!n || t === n || ld(t))) {
        return t;
    }
    return n;
};

const Nu = (t, n, e) => {
    const s = Oe;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Pu(o)) {
                o.h |= 4;
                yn(t, o.ht, 1);
            } else if (o instanceof qs) {
                o.invalidate();
            } else if (r === ":") {
                yn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Ut(o, n);
                    yn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Ys) {
                    const e = i.data;
                    const c = {
                        isConst: e.et,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[es];
                            if (!o) {
                                o = new Map;
                                s[es] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(es);
                        if (!n) {
                            n = new Map;
                            t.setProp(es, n);
                        }
                        n.set(r, c);
                    }
                    yn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Cu = t => Be(t) && typeof t[$f] === "function";

const Ou = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const ju = t => {
    t.h |= 4;
};

const Lu = [];

function Mn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Pu(t)) {
            return `Task(${Mn(t.bt)})`;
        }
        if (Ke(t)) {
            return `Qrl(${t._t})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Lu.includes(t)) {
                return "*";
            }
            Lu.length;
            try {
                Lu.push(t);
                if (Array.isArray(t)) {
                    return pl(t) ? "(" + (_l(t, Ze, null) || "vnode") + ")" : t.map(Mn);
                }
                if (qu(t)) {
                    return t instanceof Js ? "WrappedSignal" : t instanceof Ms ? "ComputedSignal" : "Signal";
                }
                if (zu(t)) {
                    return "Store";
                }
                if (Zs(t)) {
                    return Fu(t);
                }
                if (pl(t)) {
                    return "(" + (_l(t, Ze, null) || "vnode") + ")";
                }
            } finally {
                Lu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Fu = t => {
    if (Zs(t)) {
        if (typeof t.type === "function") {
            const n = t.type[wa];
            if (n) {
                const [t] = n;
                return "Component(" + t._t + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Mn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Fu(e);
                    }
                } else {
                    n += Fu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Du = t => t[Rs];

const Xu = t => t?.[ks] || null;

const Wu = (t, n) => {
    const e = Du(t);
    e && e.force(n);
};

const Vu = (t, n) => {
    const e = Du(t);
    if (e) {
        return (e.ft?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Uu = t => Xu(t) || t;

const zu = t => ks in t;

function xn(t, n, e) {
    return new Proxy(n, new Qu(e, t || null));
}

const Bu = (t, n, e) => {
    if (ze(t) && e) {
        let s = e.$t.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.$t.set(t, s);
        }
        return s;
    }
    return t;
};

class Qu {
    h;
    $;
    ft=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Xu(this);
        Nu(this.$, this, Cn(n, t, this.ft));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === ks) {
                return t;
            }
            if (n === Rs) {
                return this;
            }
            return t[n];
        }
        const e = xf();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.sn;
            o && In(t, Array.isArray(t) ? Ps : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && Be(s) && !Object.isFrozen(s) && !zu(s) && !Object.isFrozen(t)) {
            return Bu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Uu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Nn(n, s, t, this);
        } else {
            Nn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Nu(this.$, this, Cn(t, n, this.ft));
        return !0;
    }
    has(t, n) {
        if (n === ks) {
            return !0;
        }
        if (typeof n === "string") {
            const e = xf();
            if (e) {
                const s = e.sn;
                s && In(t, Array.isArray(t) ? Ps : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = xf();
        const e = n?.sn;
        e && In(t, Ps, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function In(t, n, e, s, o) {
    const r = e.ft ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = Ce;
    const l = __EXPERIMENTAL__.suspense && e instanceof Qu && c;
    Au(i, s);
    Mu(s, t);
    if (c) {
        const i = Iu(o, e.$);
        l && i?._n?.(t, s, n, r);
        xu(s, i);
    }
}

function Nn(t, n, e, s) {
    e[t] = n;
    const o = Cn(e, t, s.ft);
    o && Nu(s.$, s, o);
}

function Cn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Ps);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Hu = Symbol();

const Ju = [ void 0, null, !0, !1, "", ds, ps, Es, Ps, hs, _o, vo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const Yu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const Gu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function On(t, n, e) {
    let s = n._t;
    let o = n.gt;
    const r = mr();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => Ke(t) && t._t == Ge)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.Et(null, 0, e) + "";
    } else {
        o || (o = t.St(n.st));
        if (!o) {
            throw Ye(14, [ n._t ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.kt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function jn(t, n, e, s) {
    return sa(t, n, null, null, e, s);
}

function Ln(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return jn(o, r, i, n);
}

class Ku {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Zu {
    Yn;
    Gn=0;
    Pt=[];
    Kn=0;
    Zn=new Set;
    te=new Map;
    ne;
    ee=new Map;
    ie=0;
    Ut;
    re=typeof Temporal !== "undefined";
    constructor(t) {
        this.Yn = t;
        this.Ut = t.Ut;
    }
    async serialize() {
        const t = this.ie;
        this.ie = 0;
        try {
            await this.outputRoots();
        } finally {
            this.ie = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.ie;
        this.ie = s;
        this.Ut.write(Lr);
        this.Yn.se = 0;
        try {
            this.Ut.write(t + "");
            this.Ut.write(Dr);
            this.Ut.write(Lr);
            await this.outputSelectedRoots(n);
            this.Ut.write(Fr);
            const s = this.getForwardRefsPayload();
            this.Yn.se = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Ut.write(Dr);
                s ? this.outputForwardRefsArray(s) : this.Ut.write("0");
            }
            if (e !== void 0) {
                this.Ut.write(Dr);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Ut.write(jr);
                    this.writeRootRefPath(e);
                    this.Ut.write(jr);
                }
            }
        } finally {
            this.ie = o;
        }
        this.Ut.write(Fr);
    }
    oe(t) {
        this.Ut = t;
    }
    outputArray(t, n, e) {
        this.Ut.write(Lr);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Ut.write(Dr) : s = !0;
            e(t[n], n);
        }
        this.Ut.write(Fr);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : jr + t + jr;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Ut.write(n.slice(s, e));
            this.Ut.write("<\\/");
            s = e + 2;
        }
        this.Ut.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Ut.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Ut.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Ut.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Ut.write(jr);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Ut.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Ut.write(jr);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Ut.write(t + Dr);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Ut.write(jr);
                this.writeRootRefPath(n);
                this.Ut.write(jr);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Ut.write(t + Dr);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Ut.write(t + Dr + n);
        } else if (typeof n === "string") {
            this.Ut.write(t + Dr);
            this.outputString(n);
        } else {
            this.Ut.write(t + Dr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Yn.getSeenRef(t);
        const o = !e && this.te.get(t);
        if (s) {
            s.ne && this.isSeenInStreamedRoot(s) && (s = this.Yn.le(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Yn.ue(t, this.ne, n);
            }
            s = this.Yn.kt(t, !0);
        }
        if (s.ne) {
            if (this.ne) {
                this.Yn.ce(s, t);
            } else {
                this.Yn.ce(s, t, n);
                t = this.Yn.fe[n];
            }
        }
        if (typeof o === "number") {
            this.Pt[o] = s.Nt;
            this.te.delete(t);
        }
        const r = t instanceof cc ? t.ae : s.Nt;
        if (!this.ne && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.ne; ) {
            t = t.ne;
        }
        return t.Nt < this.ie;
    }
    writeValue(t, n) {
        if (hf(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === Es) {
                    this.output(3, 7);
                } else if (t === Ps) {
                    this.output(3, 8);
                } else if (t === hs) {
                    this.output(3, 9);
                } else {
                    if (t !== Hu) {
                        throw Ye(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === _o) {
                    this.output(3, 10);
                } else if (t === vo) {
                    this.output(3, 11);
                } else if (Ke(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = On(this.Yn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Yn.kt(n);
                            const i = this.Yn.kt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.ee.get(l);
                            if (u) {
                                const t = this.Yn.kt(u);
                                this.output(1, t);
                                return;
                            }
                            this.ee.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!va(t)) {
                        throw Ye(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[wa];
                        this.Yn.he.add(n._t);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === ds) {
                    this.output(3, 5);
                } else if (t === ps) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof cc) {
                    this.output(1, t.ae);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.ne;
                        this.ne = e;
                        this.writeObjectValue(t);
                        this.ne = n;
                    }
                }
                break;

              default:
                throw Ye(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (gs(t)) {
            const n = t[cs];
            this.output(38, [ lc(n), n.varProps, n.constProps, t[fs].ft ]);
        } else if (t instanceof Ys) {
            const {O: n, et: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof Ss) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Ku) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (zu(t)) {
            const n = Du(t);
            const e = Xu(t);
            const s = n.h;
            const o = n.ft;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Yn.$t.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Cu(t)) {
            const n = t[$f](t);
            if (Ji(n)) {
                const t = this.resolvePromise(n, (t, n) => new tc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.ne.Nt;
                this.ne = this.ne.ne;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        hf(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Yn.de(t)) {
            this.Yn.pe(t.$e, 16);
            this.output(11, t.$e.id);
        } else if (t instanceof qs) {
            if (t instanceof Is) {
                const n = function e(t, n) {
                    if (n === Es) {
                        return n;
                    }
                    return Gi(t.Ot.resolved || t.Ot.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && $f in n && (e = n[$f](n));
                        e === void 0 && (e = Es);
                        return e;
                    });
                }(t, t.Ct);
                if (Ji(n)) {
                    const e = this.resolvePromise(n, (n, e) => new tc(34, n, e, t.ft, t.Ot));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Ot, t.ft, n ]);
                }
                return;
            }
            if (t instanceof Js) {
                this.output(31, [ ...Fn(this.Yn, t), t.h, t.m, ...t.ft || [] ]);
            } else if (t instanceof Ms) {
                let n = t.Ct;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = hf(t.Ct);
                const i = !!(t.h & 512);
                const c = i && !!t.jt;
                const l = i && t.Tt !== 0 ? t.Tt : void 0;
                const u = i && t.Ft !== 1 ? t.Ft : void 0;
                const f = i && t.Xt !== 0 ? t.Xt : void 0;
                const a = i && t.h & -25 || void 0;
                o || r || c ? n = Es : e ? n = t.Ct : s && (n = Es);
                const h = [ t.Ot, t.ft ];
                if (i) {
                    h.push(t.yt, t.wt, t.jt);
                    h.push(a || void 0);
                }
                n === Es && l === void 0 && u === void 0 && f === void 0 || h.push(n === void 0 ? Hu : n);
                if (i) {
                    h.push(l);
                    h.push(u);
                    h.push(f);
                }
                this.output(i ? 33 : 32, h);
            } else {
                const n = t.Ct;
                const e = [ n === void 0 ? Hu : n ];
                t.ft && e.push(...t.ft);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.Yn.ye(t)) {
            const n = this.Yn.kt(t);
            this.Yn.me(t, Ii, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                nc(e, t => {
                    this.Yn.kt(t);
                });
                this.Yn.pe(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Yn.pe(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Zs(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Ru) {
            const n = [ t.bt, t.h, t.Nt, t.ht ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (Ji(t)) {
            const n = this.resolvePromise(t, (t, n) => new tc(24, t, n));
            this.output(2, n);
        } else if (t instanceof tc) {
            if (t.we === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ft, t.ve ]);
                } else {
                    if (!t.be) {
                        console.error(t.ve);
                        throw Ye(33);
                    }
                    {
                        const n = this.ne.Nt;
                        this.ne = this.ne.ne;
                        this.writeValue(t.ve, n);
                    }
                }
            } else {
                this.output(24, [ t.be, t.ve ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof oc) {
            const n = t._e;
            if (this.getSeenRefOrOutput(n, this.ne.Nt, !0)) {
                let t = this.te.get(n);
                if (t === void 0) {
                    t = this.Kn++;
                    this.te.set(n, t);
                    this.Pt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.re && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.re && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.re && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.re && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.re && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.re && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.re && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.re && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!pl(t)) {
                throw Ye(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Kn++;
        t.then(s => {
            this.Zn.delete(t);
            this.Pt[e] = this.Yn.kt(n(!0, s));
        }).catch(s => {
            this.Zn.delete(t);
            this.Pt[e] = this.Yn.kt(n(!1, s));
        });
        this.Zn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Yn.ge + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {fe: n} = this.Yn;
        for (;this.Gn < n.length || this.Zn.size; ) {
            let e = t > 0;
            for (;this.Gn < n.length; this.Gn++) {
                e ? this.Ut.write(Dr) : e = !0;
                this.writeValue(n[this.Gn], this.Gn);
                t++;
            }
            if (this.Zn.size) {
                try {
                    await Promise.race(this.Zn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Zn.size; ) {
            if (e < t.length) {
                n ? this.Ut.write(Dr) : n = !0;
                const s = t[e++];
                this.writeValue(this.Yn.fe[s], s);
                continue;
            }
            try {
                await Promise.race(this.Zn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Pt.length - 1;
        for (;t >= 0 && this.Pt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Pt.length - 1 ? this.Pt : this.Pt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Ut.write(jr);
                this.writeRootRefPath(t);
                this.Ut.write(jr);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Ut.write(Lr);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Yn.Ee = this.Yn.fe.length;
        this.Yn.Se = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Ut.write(Dr);
            this.Ut.write(14 + Dr);
            this.outputForwardRefsArray(n);
        }
        this.Ut.write(Fr);
        this.Yn.ke = this.Yn.fe.length + (this.Yn.Se ? 1 : 0);
        this.Yn.se = e;
    }
}

class tc {
    we;
    be;
    ve;
    ft;
    bt;
    constructor(t, n, e, s, o) {
        this.we = t;
        this.be = n;
        this.ve = e;
        this.ft = s;
        this.bt = o;
    }
}

const nc = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (ec(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === Ii || t === Ci && (Cr(s) || ic(e, s))) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const ec = t => typeof t === "object" && t !== null && !Cr(t);

const ic = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, si)) {
        return !1;
    }
    const s = n[cs];
    return Cr(s.varProps) && !rc(n) && !sc(t[mi]);
};

const rc = t => !!t[fs].ft?.size;

const sc = t => t instanceof Map && t.has(":");

function Fn(t, n) {
    n.Rt && n.Rt[0] === "{" && (n.Rt = `(${n.Rt})`);
    const e = t.Et(n.Rt, n.ut.length, n.lt);
    return [ e, n.ut ];
}

class oc {
    _e;
    constructor(t) {
        this._e = t;
    }
}

const lc = t => new oc(t);

let uc = () => !1;

class cc {
    ae;
    constructor(t) {
        this.ae = t;
    }
}

class fc {
    NodeConstructor;
    DomRefConstructor;
    St;
    me;
    $t;
    Ut;
    Re=new Map;
    Pe=new Map;
    Te=0;
    qe=[];
    fe=[];
    Ae=[];
    Me;
    ge=0;
    ke=0;
    se=0;
    Ee=0;
    Se=!1;
    qt=new Set;
    It=new Set;
    xt=new Set;
    he=new Set;
    xe;
    pe=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this.me = s;
        this.$t = o;
        this.Ut = r;
        this.xe = new Zu(this);
    }
    async Vt() {
        await this.xe.serialize();
    }
    async Ie(t, n, e, s) {
        await this.xe.serializePatch(t, n, e, s);
    }
    oe(t) {
        this.Ut = t;
        this.xe.oe(t);
    }
    getSeenRef(t) {
        return this.Re.get(t);
    }
    ue(t, n, e) {
        const s = {
            Nt: e,
            ne: n
        };
        this.Re.set(t, s);
        return s;
    }
    Ne(t) {
        const n = [];
        for (;t.ne; ) {
            n.unshift(t.Nt);
            t = t.ne;
        }
        n.unshift(t.Nt);
        return n;
    }
    ce(t, n, e) {
        const s = this.Ne(t);
        const o = e === void 0;
        e === void 0 && (e = this.fe.length);
        this.fe[e] = new cc(s);
        o && (this.Ae[e] = n);
        t.ne = null;
        t.Nt = e;
        o && this.Me?.(e, this.fe[e], n);
    }
    kt(t, n = !1) {
        let e = this.Re.get(t);
        let s;
        if (e) {
            e.ne && this.ce(e, t);
            s = e.Nt;
        } else {
            s = this.fe.length;
            e = {
                Nt: s
            };
            this.Re.set(t, e);
            this.fe.push(t);
            this.Ae.push(t);
            this.Me?.(s, t, t);
        }
        return n ? e : s;
    }
    le(t) {
        const n = this.fe.length;
        const e = {
            Nt: n
        };
        this.Re.set(t, e);
        this.fe.push(t);
        this.Ae.push(t);
        this.Me?.(n, t, t);
        return e;
    }
    Ce(t, n) {
        const e = this.fe.length;
        const s = {
            Nt: e
        };
        this.Re.set(n, s);
        this.fe.push(t);
        this.Ae.push(n);
        return e;
    }
    ye(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    de(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Oe(t) {
        const n = this.Re.get(t);
        return n && (n.ne ? void 0 : n.Nt);
    }
    Et(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.Pe.get(t);
        if (o === void 0) {
            o = this.Te + this.qe.length;
            this.Pe.set(t, o);
            if (s) {
                this.qe.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.qe.push(e += ")=>" + t);
            }
        }
        return o;
    }
    je(t, n) {
        this.Te = t;
        if (n) {
            this.Pe.clear();
            for (let t = 0; t < n.length; t++) {
                this.Pe.set(n[t], t);
            }
        }
    }
}

const ac = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Or(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    uc = n ? t => t instanceof n : () => !1;
    return new fc(t, n, e, s, o, r);
};

const hc = (t, n) => t[n];

const dc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        zu(t) && (t = Xu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!dc(Of(hc, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!dc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Pu(t)) {
            return !0;
        }
        if (gs(t)) {
            return !0;
        }
        if (Ji(t)) {
            return !0;
        }
        if (Zs(t)) {
            return !0;
        }
        if (Cu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ys) {
            return !0;
        }
        if (uc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ke(t) || va(t) || t === _o || t === vo) {
            return !0;
        }
    } else if (t === hs || t === Es || t === Ps) {
        return !0;
    }
    return !1;
};

const pc = (t, n) => {
    let e = pl(t) ? En.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Be(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let $c = !1;

const yc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && ($c = !0);
            const n = `{${Be(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${pc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = wc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${yc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${mc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = $c ? "" : `(${JSON.stringify(t).length} chars)`;
        $c = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const mc = t => Gu[t] || `Unknown(${t})`;

const wc = t => Yu[t] || `Unknown(${t})`;

function Dn(t, n, e, s = 0) {
    const o = Xn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Xn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Pt = t[i + 1]);
        yield;
    }
}

const vc = new WeakMap;

const bc = /^[A-Za-z0-9+/]*$/;

const _c = t => {
    const n = t.Wt === void 0;
    t.Wt ??= new Map;
    return n;
};

const gc = (t, n) => {
    if (n) {
        t.Wt.clear();
        t.Wt = void 0;
    }
};

const Ec = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        const s = t.Bt(e);
        return s === -1 || s === void 0 ? hs : t._(s);

      case 14:
        return e;

      case 3:
        return Ju[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t._(i);
                const f = t._(l);
                n = jn(u, f, r !== -1 ? s : null, t);
            } else {
                n = jn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Ru(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return ma(null);

      case 30:
        return new qs(t, 0);

      case 31:
        return new Js(t, null, null, null);

      case 32:
        return new Ms(t, null);

      case 33:
        return new Ns(t, null, void 0, {});

      case 34:
        return new Is(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Ec(t, s, o);
            const i = Bu(r, 0, t);
            Zc(s) && t.Wt.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Gs(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        vc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !bc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw Ye(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return m(null);

      case 10:
        return Wn(t, e);

      case 11:
        const l = Wn(t, e);
        if (pl(l)) {
            Gl(l);
            return mu(l);
        }
        throw Ye(17, [ typeof l ]);

      case 39:
        return new Ys({});

      case 42:
        return new Ys({
            O: null,
            et: !0
        });

      case 43:
        return new Ys({
            O: null,
            et: !1
        });

      case 40:
      case 44:
        return new Ss(null, null, null, null);

      case 41:
        return new Ku;

      default:
        throw Ye(18, [ n ]);
    }
};

function Wn(t, n) {
    return n ? t.rootVNode ? ql(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Sc = (t, n, e) => {
    let s = null;
    let o = null;
    if (Je(t)) {
        o = t;
    } else {
        if (!He(t)) {
            throw Ye(7, [ t ]);
        }
        s = t;
    }
    return sa(s, n, null, o, e);
};

const kc = (t, n, e) => sa(null, n, t, null, e);

const Rc = (t, n) => sa(null, t, null, null, n);

const Pc = (t, n, e) => {
    const s = Rc(t, e);
    return s;
};

const Tc = (t, n, e, s) => sa(t, e, null, n, s);

const qc = (t, n, e, s, o) => {
    const r = Tc(t, n, e, o);
    r.Le(s);
    return r;
};

const Ac = (t, n, e, s) => {
    const o = Sc(t, n, s);
    return o;
};

const Mc = (t, n, e, s) => {
    const o = kc(t, n, s);
    return o;
};

const xc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Ic = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Vn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Nc = (t, n, e) => new Js(null, t, n, e || null);

class Cc {
    Fe;
    $t;
    De=null;
    Jn=!1;
    en;
    _;
    un;
    Xe=0;
    Qt=null;
    We=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.un = t;
        this.en = n;
        this.Fe = Xr;
        this.$t = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return Ff(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return ac(t, n, e, this.setHostProp.bind(this), this.$t, s);
    }
    dt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Oc = Symbol();

const fd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Oc] = t;
    return n;
};

class jc {}

function Un(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function zn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === jc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        Ji(n) && await n;
                    }
                    continue;
                }
                Bn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                Ji(n) && await n;
            }
        }
    })();
}

function Bn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (qu(e)) {
            (function s(t, n) {
                const e = n instanceof Js ? n.rt() : n;
                if (e instanceof Ms) {
                    const n = e.Tt;
                    if (n && !(e.h & 256)) {
                        t.kt(e);
                        t.qt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(ps);
            const o = t.getOrCreateLastNode();
            const r = e instanceof Js ? e.rt() : e;
            n(t.closeFragment);
            n(() => Ff(r, o, ".", t));
            n(jc);
        } else if (Ji(e)) {
            t.openFragment(ps);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await zn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = ws(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.At) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = o.children;
                l != null && n(l);
            } else if (Je(r)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && Oc in t)(r)) {
                    n(() => (t => t[Oc])(r)(t, o, s, n));
                    return;
                }
                if (r === vo) {
                    const e = o.key != null ? {
                        [Ni]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === _o) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = ws(o, Ri);
                        c && (i[Ri] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = k(l, o, t);
                        i[ui] = f;
                        n(Un(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(u, f) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(Un(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = ps;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === So) {
                    t.commentNode(ws(o, "data") || "");
                } else if (r === Ro) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = Je(e) ? e({
                        async write(n) {
                            await zn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    Ji(r) && n(Promise);
                } else if (r === Eo) {
                    t.htmlNode(ws(o, "data"));
                } else if (r === ko) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (va(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[wa];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(si, o);
                        s.setProp(Ci, r);
                        n.key !== null && s.setProp(Ni, n.key);
                        return Ko(t, s, s, o, r);
                    })(t, o, r);
                    n(Un(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (Ji(l)) {
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const o = nr(i.getProp($i));
                            n(e);
                            n(Un(s, o, c));
                        });
                    } else {
                        n(l);
                        const t = nr(i.getProp($i));
                        n(Un(s, t, c));
                    }
                } else {
                    const e = {
                        [Ni]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Ko(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    Ji(i) && n(Promise);
                }
            }
        }
    }
}

const Lc = () => Zf;

const Fc = async t => {
    const [n, e] = Zf;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Dc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e) {
        return e;
    }
    const r = sa(null, "_rsc", Fc, null, [ t, {} ], o.$);
    const i = js(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Xc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (Ji(t)) {
        return t.then(n, s);
    }
    const o = Wc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return Ji(i) ? i.then(n, s) : n(i);
};

const Wc = t => t && t.__brand === "resource";

function Qn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        n._t.startsWith("_") || !Array.isArray(n.Mt) && !s || (n = sa(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = On(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (Ke(o)) {
                i(c(o));
                Hn(t, n, o);
            } else if (o != null) {
                const e = Qn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (Ke(r)) {
        o = c(r);
        Hn(t, n, r);
    }
    return o;
}

function Hn(t, n, e) {
    const s = sr(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.xt.add(r);
        t.It.add(e);
    }
}

const Vc = (t, n, e) => {
    Bc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Uc = (t, n, e) => {
    Bc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const zc = (t, n, e) => {
    Bc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Bc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = Qc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + rr(i), e, s);
            }
        } else {
            r(t + rr(n), e, s);
        }
    }
};

const Qc = () => {
    const t = Nf();
    const n = t.m;
    const e = n;
    let s = t.$.getHostProp(e, Xi);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Xi, s);
    }
    let o = t.$.getHostProp(e, Wi);
    o === null && (o = 0);
    t.$.setHostProp(e, Wi, o + 1);
    let r = t.$.getHostProp(e, Vi);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Vi, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Hc = function(t, n) {
    const e = Ee(n);
    return Tf(e, () => {
        typeof this === "string" && ta(na(e, this));
        const s = Zf?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = Zf?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        yn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let Jc;

function Jn(t) {
    const n = xf();
    if (!n) {
        return;
    }
    Jc ||= kc(Hc, "_hmr");
    const e = n.m;
    const s = Jc.w([ e, t ]);
    Uc("qHmr", s);
}

function Yn(t, n, e, s, o) {
    const r = dl();
    gl(r, ui, o);
    r.parent = n;
    gl(n, o, r);
    gl(r, si, e);
    gl(r, Ci, s);
    r.dirty = 4;
    hn(t, r, 1);
    return r;
}

function Gn(t, n) {
    gl(t, oi, n);
    t.flags |= 2048;
}

function Kn(t, n, e) {
    gl(n, Ci, e);
    yn(t, n, 4);
}

function Zn(t, n, e, s) {
    gl(n, s, null);
    const o = [];
    Et(t, o, e);
    Cl(o);
    if (e.flags & 2048) {
        const t = _l(e, oi, null);
        t && t.replaceChildren();
        gl(e, oi, null);
        e.flags &= -2049;
    }
}

let Yc = Promise.resolve();

const Gc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Kc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Gc.has(t));
};

function* te(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ee(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ne(t, n, e = Array(n.length / 2)) {
    const s = _c(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t._;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : Ec(t, i, c);
        }
        return e[s];
    };
    t._ = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            Zc(r) && (yield* ie(t, c, r, i));
            yield;
        }
    } finally {
        t._ = i;
        gc(t, s);
    }
    return e;
}

function* ee(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Ec(t, n, e);
    Zc(n) && (yield* ie(t, s, n, e));
    return s;
}

function* ie(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* te(t, s));
    switch (e) {
      case 4:
        yield* te(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Kc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = vc.get(t);
            if (e) {
                if (vc.has(o)) {
                    throw Ye(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                Kc(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t.bt = e[0];
            t.h = e[1];
            t.Nt = e[2];
            t.ht = e[3];
            break;
        }

      case 29:
        n[wa][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Ct = e[0];
            t.ft = new Set(e.slice(1));
            se(t.ft, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.lt = t.getSyncFn(o[0]);
            e.ut = o[1];
            e.Ct = Es;
            e.h = o[2];
            e.h |= 1;
            e.m = o[3];
            e.ft = new Set(o.slice(4));
            (function r(t) {
                if (t.m !== null && pl(t.m)) {
                    const n = t.m;
                    const e = t.ft;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (He(e)) {
                                const o = _l(n, e, null);
                                if (o !== null) {
                                    t.Ct = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Yl(n);
                        e && n.firstChild === n.lastChild && wl(e) && (t.Ct = Hl(e));
                    }
                }
            })(e);
            se(e.ft, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Ot = e[0];
            e[1] && (t.ft = new Set(e[1]));
            e[2] && (t.yt = new Set(e[2]));
            e[3] && (t.wt = new Set(e[3]));
            e[4] && (t.jt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Lt = !0);
            const o = e.length > 6;
            o && (t.Ct = e[6]);
            t.Ct === Es && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.Ft = e[8] ?? 1;
                t.Dt = [];
            }
            t.Xt = e[9] ?? 0;
            se(t.ft, t);
            se(t.yt, t);
            se(t.wt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Ot = r[0];
            const i = o.Ot.resolve(t).catch(() => {});
            Yc = Yc.finally(() => i);
            r[1] && (o.ft = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Ct = r[2]);
            e !== 34 && o.Ct !== Es && (o.h &= -2);
            se(o.ft, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === hs) {
                o = new Gs(vo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[cs] = o;
            const r = t[fs];
            r.ft = e[3];
            oe(r.ft, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.et = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            re(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            re(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Uu(n);
            const o = t.Wt.get(e);
            if (o) {
                t.Wt.delete(e);
                yield* ie(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Du(n);
            c.h = r;
            c.ft = i;
            oe(c.ft, e);
            break;
        }

      default:
        throw Ye(16, [ e ]);
    }
}

function re(t) {
    const n = Ce;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[Vr] ||= new Map;
    e[Vr].set(t.property, t);
}

function se(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function oe(t, n) {
    if (t) {
        for (const [, e] of t) {
            se(e, n);
        }
    }
}

const Zc = t => t >= 23 || t === 4 || t === 5;

const tf = new WeakMap;

const nf = Symbol();

const ef = (t, n) => {
    if (!Array.isArray(n) || pl(n) || (t => Be(t) && nf in t)(n)) {
        return n;
    }
    let e = tf.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new rf(t, n));
        tf.set(n, e);
    }
    return e;
};

class rf {
    $;
    Ve;
    constructor(t, n) {
        this.$ = t;
        this.Ve = n;
    }
    get(t, n, e) {
        if (n === nf) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Ve.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Ve[o];
        const i = this.Ve[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = _c(c);
        try {
            const e = Ec(c, r, i);
            Reflect.set(t, n, e);
            this.Ve[o] = 0;
            this.Ve[o + 1] = e;
            Zc(r) && ((t, n, e, s) => {
                const o = _c(t);
                try {
                    const o = ie(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    gc(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            gc(c, l);
        }
    }
    has(t, n) {
        if (n === nf) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === nf) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Ve.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Ve[i] = 0;
        this.Ve[i + 1] = e;
        return !0;
    }
}

const sf = t => {
    if (!t.Ue) {
        t.Ue = !0;
        t.ze();
    }
};

const of = (t, n, e) => {
    const s = {
        Be: t,
        ze: void 0,
        Ue: !1
    };
    const o = hr(() => {
        ((t, n, e) => {
            t.Ue = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Be.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        sf(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.cn?.();
            n(t);
        }, t => {
            o.cn?.();
            e(t);
        });
    });
    s.ze = o;
    return s;
};

async function le(t) {
    const n = ac(null, null, () => "", () => {}, new WeakMap);
    n.kt(t);
    await n.Vt();
    return n.Ut.toString();
}

async function ue(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = ae(n, () => e);
    s.zt = e;
    await lf(ne(s, n, e));
    return e[0];
}

const lf = t => new Promise((n, e) => {
    const s = of(t, n, e);
    sf(s);
});

function ce(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function fe(t) {
    let n;
    const e = ae(t, () => n);
    n = ef(e, t);
    e.zt = n;
    return e;
}

function ae(t, n) {
    const e = {
        _: t => ce(t, n()),
        Bt: t => e.Pt?.[+t],
        getSyncFn: () => () => {},
        $t: new WeakMap,
        element: null,
        Pt: null
    };
    Dn(t, e);
    return e;
}

const uf = (t, n) => {
    const e = new WeakSet;
    return Of(cf, t, e, "_", n);
};

const cf = (t, n, e, s) => {
    const o = Uu(t);
    if (o == null) {
        return t;
    }
    if (af(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (qu(o)) {
            return t;
        }
        if (dc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (Ji(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Qe(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Ye(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw Ye(3, [ o ]);
                    }
                    cf(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Jr) {
                return t;
            }
            if (ze(o)) {
                for (const [t, s] of Object.entries(o)) {
                    cf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Ye(3, [ i ]);
    }
    return t;
};

const ff = /*#__PURE__*/ new WeakSet;

const af = t => {
    if (Be(t) || Je(t)) {
        return !ff.has(t) && !(pf in t);
    }
    return !0;
};

const hf = t => !!t && (Be(t) || typeof t === "function") && (ff.has(t) || pf in t);

const df = t => {
    (Be(t) && t !== null || typeof t === "function") && ff.add(t);
    return t;
};

const pf = Symbol();

const $f = Symbol();

const yf = t => /*#__PURE__*/ Object.freeze({
    id: rr(t)
});

const mf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o.m, t, n);
    s(1);
};

const wf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o.m, t);
    if (typeof n === "function") {
        return s(qe(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Ye(8, [ t.id ]);
};

const vf = t => {
    const n = If();
    const e = n.m;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const bf = /*#__PURE__*/ yf("qk-error");

const ad = (t, n = t => t.boundary.pending.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const hd = new WeakMap;

class dd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = pd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return ad(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const pd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const $d = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = xf()?.$;
    return t?.outOfOrderStreaming === !0 && !ld(t);
};

const _f = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && Nu(t, n, r);
};

const gf = new WeakMap;

function* he(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Qt}"]${fi}`);
    const o = Ef(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(ai) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* de(t, e, i.textContent);
        yield;
    }
}

const Ef = t => {
    let n = gf.get(t);
    if (!n) {
        n = new WeakSet;
        gf.set(t, n);
    }
    return n;
};

function* de(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.Ht.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.Ht[e * 2 + t] = s[t];
            yield;
        }
        yield* Xn(n.Ht, t, e * 2);
        n.Jt = ef(t, n.Ht);
        n.Jt.length = n.Ht.length / 2;
        n.Yt = n.Pt;
    }(t, n, s, o);
    Sf(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t._(s.rootId);
            const r = s.subscriptions;
            if (o instanceof qs) {
                r instanceof Set && _f(t, o, o, o.ft ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Du(o);
                const e = Xu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ft ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    _f(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n._(i));
}

const Sf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Yt ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Pt = e;
};

const kf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function pe(t, n) {
    const e = t.qVNodeDataState ||= {
        Gt: [],
        Kt: null
    };
    t.qProcessVNodeDataPatch ||= n => pe(t, me(t, n));
    t.qVNodeDataReady = !1;
    e.Gt.push(n);
    $e(t, e);
}

function $e(t, n) {
    if (n.Kt) {
        return;
    }
    const e = n.Gt.shift();
    if (!e) {
        ye(t);
        return;
    }
    n.Kt = of(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.Kt = null;
            $e(t, n);
        }
    }, e => {
        n.Kt = null;
        Fe(e);
        ye(t);
    });
    sf(n.Kt);
}

function ye(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* me(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* we(t, s || void 0, e, o, n.textContent));
}

function* we(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const b = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const v = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const _ = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;Rf(m = r.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = v(e)); ) {
                    e = e.parentNode;
                }
                yield* _(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = v(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                yield* _(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = v(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* _(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += k();
                        if (m === 126) {
                            g = p;
                            y++;
                            m = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = Pf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? ri(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== ii || n.charCodeAt(1) !== ii || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* E(c, s, t);
                    S = v(s);
                    S && (n.currentNode = S);
                }
            }
            yield;
        } while (s = S || n.nextNode());
    };
    const g = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* _(r, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const E = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* g(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* E(e, s, n, o) : yield* g(e, s, o);
        return;
    }
    yield* m(t);
    const S = t.createTreeWalker(t, 129);
    yield* _(S, null, S.firstChild(), null, "", null, null);
}

const Rf = t => 33 <= t && t <= 46;

const Pf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Rf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function ve(t) {
    return t.Zt === 3;
}

function be(t, n) {
    const e = t.tn ||= {
        Gt: [],
        Kt: null
    };
    t.Zt = 2;
    e.Gt.push(n);
    _e(t, e);
}

const Tf = (t, n) => {
    const e = t;
    if (ve(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!ve(e)) {
                    (e.nn ||= []).push(s);
                    return;
                }
                kf(e.document, () => {
                    ve(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function _e(t, n) {
    if (n.Kt) {
        return;
    }
    const e = n.Gt.shift();
    if (!e) {
        ge(t);
        return;
    }
    n.Kt = of(e, () => {
        n.Kt = null;
        _e(t, n);
    }, e => {
        n.Kt = null;
        Fe(e);
        ge(t);
    });
    sf(n.Kt);
}

function ge(t) {
    const n = t.Zt;
    if (n !== 2) {
        return;
    }
    t.Zt = 3;
    t.tn = void 0;
    const e = t.nn;
    t.nn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Ee(t) {
    const n = ke(t);
    if (!n) {
        throw Ye(24);
    }
    return Se(n);
}

function Se(t) {
    const n = t;
    return n.qContainer ||= new qf(n);
}

function ke(t) {
    return t.closest(Ti);
}

function Re(t, n) {
    const e = t + "";
    const s = n?.closest(Ti);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            pe(t, function* i(t, n, e, s, o, r) {
                yield* we(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* me(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        kf(t, () => {
            o.element.qContainer === o && be(o, he(o, e));
        });
    }
}

class qf extends Cc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    $t=new WeakMap;
    Qe;
    Qt;
    Pt=null;
    vNodeLocate=t => ql(this.rootVNode, t);
    Zt=0;
    nn=void 0;
    tn=void 0;
    Ht;
    Jt;
    Yt=null;
    He=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Si);
        if (!this.qContainer) {
            throw Ye(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.We = t.getAttribute(vi);
        this.Qt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = al(this.element);
        this.Ht = [];
        this.Jt = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= Re);
        this.Qe = wi(n, this.Qt) || ds;
        this.Je();
        t.qContainer = this;
        t.qDestroy = () => this.cn();
        this.Zt = 1;
        (function e(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            pe(e, function* s(t) {
                yield* we(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        kf(n, () => {
            this.Zt === 1 && be(this, this.Ye());
        });
    }
    * Ye() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Qt}"]:not(${fi})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${fi})`);
        if (n) {
            this.Ht = JSON.parse(n.textContent);
            yield* Xn(this.Ht, this);
            this.Yt = this.Pt;
            const e = this.Ht.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.Jt = s !== null && e > 0 && e >= +s ? yield* ne(this, this.Ht) : ef(this, this.Ht);
        }
        __EXPERIMENTAL__.suspense && (yield* he(this));
        this.Ge();
        t.setAttribute(Si, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    cn() {
        this.vNodeLocate = () => null;
        this.Ht.length = 0;
        this.Jt.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Si);
        const n = t.ownerDocument;
        this.tn = void 0;
        this.Zt = 0;
        const e = n.querySelector(Ti) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    Ge() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(pi);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Bn(t, n) {
        this.Jt[t] = n;
    }
    parseQRL(t) {
        const n = Ln(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, bf);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, yi);
        s == null && this.setHostProp(t, yi, s = []);
        We(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, yi);
            if (e != null && Ue(e, n.id, 0)) {
                return Ve(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (vl(n)) {
                if (_l(n, si, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        gl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Oi:
          case Ci:
          case si:
          case yi:
          case mi:
          case Ri:
            s = this._;
            break;

          case ji:
          case Wi:
            s = parseInt;
            break;
        }
        return _l(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    _=t => ce(t, this.Jt);
    Bt(t) {
        return this.Yt?.[t];
    }
    getSyncFn(t) {
        const n = this.Qe[t];
        return n;
    }
    Ke(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, $i);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, $i, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.He == null) {
            this.He = new Set;
            const t = this.document.querySelectorAll(di);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.He.add(e.getAttribute(hi));
            }
        }
        if (!this.He.has(n)) {
            this.He.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(hi, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Je() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === zi) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.un = {
            containerAttributes: t
        };
    }
}

let Af;

let yd;

if (Ce) {
    const t = Ic();
    t && (yd = new t);
}

function Pe(t) {
    if (yd) {
        const t = yd.getStore();
        if (t) {
            return t;
        }
    }
    if (Af === void 0) {
        const n = xf();
        if (n && n.en) {
            return n.en;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Af;
}

function Te(t, n) {
    if (yd) {
        return yd.run(t, n);
    }
    const e = Af;
    try {
        Af = t;
        return n();
    } finally {
        Af = e;
    }
}

let Mf;

const xf = () => Mf;

const If = () => {
    const t = xf();
    if (!t) {
        throw Ye(9);
    }
    return t;
};

const Nf = () => {
    const t = xf();
    if (!t || t.rn !== xi) {
        throw Ye(10);
    }
    return t;
};

function qe(t, n, ...e) {
    return Ae.call(this, t, n, e);
}

function Ae(t, n, e) {
    const s = Mf;
    try {
        Mf = t;
        return n.apply(this, e);
    } finally {
        Mf = s;
    }
}

const Cf = (t, n, e = Ee(n)) => {
    const s = ql(e.rootVNode, n);
    const o = e.en;
    o && function r(t) {
        if (yd) {
            yd.enterWith(t);
            return;
        }
        Af = t;
    }(o);
    const i = xe(o, s, t);
    i.$ = e;
    return i;
};

function Me(t, n, e) {
    const s = {
        m: n,
        rn: xi,
        sn: void 0,
        en: t,
        $: e,
        ln: void 0
    };
    return s;
}

function xe(t, n, e) {
    const s = t || (e && Be(e) && "locale" in e ? e.locale : void 0);
    const o = {
        m: n,
        rn: e,
        sn: void 0,
        en: s,
        $: void 0
    };
    return o;
}

const Of = (t, ...n) => {
    if (typeof t === "function") {
        if (!Mf) {
            return t(...n);
        }
        {
            const e = Mf.sn;
            try {
                Mf.sn = void 0;
                return t(...n);
            } finally {
                Mf.sn = e;
            }
        }
    }
    if (qu(t)) {
        return t.untrackedValue;
    }
    return Uu(t);
};

const jf = /*#__PURE__*/ Me(void 0, void 0, void 0);

const Lf = (t, n, e, s, o) => {
    const r = jf.sn;
    const i = jf.$;
    try {
        jf.sn = w(n, e, o);
        jf.$ = s;
        return Ae(jf, t);
    } finally {
        jf.sn = r;
        jf.$ = i;
    }
};

const Ff = (t, n, e, s, o) => {
    t instanceof Js && t.m !== n && n && (t.m = n);
    return Lf(() => t.value, n, e, s, o);
};

const Df = () => xf()?.m;

const Xf = () => {
    const t = xf();
    if (t) {
        return t.rn;
    }
};

const Wf = () => {
    const t = xf();
    if (t) {
        return t.$;
    }
};

const Vf = t => t;

const Uf = t => t.l || Promise.resolve();

let zf = (t, n, e, s, o) => new Bf(t, n, e, s, o);

class Bf {
    gt;
    _t;
    Ze;
    ti;
    $;
    constructor(t, n, e, s, o) {
        this.gt = t;
        this._t = n;
        this.Ze = e;
        this.ti = s;
        s && this.ni(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        Oe && t && Ne(t, .8);
    }
    get st() {
        return sd(this._t);
    }
    ni(t) {
        this.ti = t;
        Ji(t) && t.then(t => this.ti = t, t => {
            console.error(`qrl ${this._t} failed to load`, t);
            this.ti = null;
        });
    }
    ei() {
        if (this.ti != null) {
            return this.ti;
        }
        if (this.gt === "") {
            const t = this.$.Qt;
            const n = this.$.element?.ownerDocument || document;
            const e = wi(n, t);
            return this.ti = e[+this._t];
        }
        Oe && this.gt && Ne(this.gt, 1);
        const t = this._t;
        const n = this.Ze ? this.Ze().then(n => n[t]) : mr().importSymbol(this.$?.element, this.gt, t);
        this.ni(n);
        return this.ti;
    }
}

Oe && import.meta.hot && (t => {
    if (!Oe || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        zf = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.gt;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.gt;
            if (i) {
                t.gt = e(i, o);
                r = !0;
            }
            const c = t.Ze?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.Ze = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t._t, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t._t}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.ti = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(Bf);

const Qf = Symbol();

const Hf = t => t?.[Qf] ?? t;

class Jf {
    ii;
    resolved=void 0;
    Mt;
    $;
    constructor(t, n, e) {
        this.ii = t;
        if (n) {
            this.Mt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.ti == null || this.Mt && typeof this.Mt === "string" || Ji(t.ti) || (this.resolved = ia(this, t.ti));
    }
}

const Yf = function(t, ...n) {
    const e = Hf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = xf();
    return Gf.call(e, s?.$).then(() => Ae.call(t, s, e.resolved, n));
};

const Gf = async function(t) {
    const n = Hf(this);
    return Gi(ra(n, t), () => n.resolved);
};

const Kf = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Qf].resolved;
        },
        set(t) {
            this[Qf].resolved = t;
        }
    },
    Mt: {
        get() {
            return this[Qf].Mt;
        },
        set(t) {
            this[Qf].Mt = t;
        }
    },
    $: {
        get() {
            return this[Qf].$;
        },
        set(t) {
            this[Qf].$ = t;
        }
    },
    ii: {
        get() {
            return this[Qf].ii;
        }
    },
    gt: {
        get() {
            return this[Qf].ii.gt;
        }
    },
    _t: {
        get() {
            return this[Qf].ii._t;
        }
    },
    st: {
        get() {
            return this[Qf].ii.st;
        }
    },
    dev: {
        get() {
            return this[Qf].ii.dev;
        }
    },
    ri: {
        value: Yf
    },
    w: {
        value: function(t) {
            const n = Hf(this);
            const e = new Jf(n.ii, t, n.Mt ? n.$ : void 0);
            return oa(e);
        }
    },
    s: {
        value: function(t) {
            const n = Hf(this);
            n.ii.ni(t);
            n.resolved = ia(n, t);
        }
    },
    resolve: {
        value: Gf
    },
    getSymbol: {
        value: function() {
            return Hf(this).ii._t;
        }
    },
    getHash: {
        value: function() {
            return Hf(this).ii.st;
        }
    },
    getCaptured: {
        value: function() {
            const t = Hf(this);
            ea(t);
            return t.Mt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Hf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Gf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Ae(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Zf = null;

const ta = t => {
    Zf = t;
};

const na = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t._(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const ea = t => {
    const n = t.Mt;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw Ye(13);
        }
        const s = Yc;
        Zf = t.Mt = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return na(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return na(t, n, s + 1, o);
        })(e, n);
        if (Yc !== s) {
            return Yc;
        }
    } else {
        Zf = n || null;
    }
};

const ia = (t, n) => {
    if (typeof n !== "function" || !t.Mt) {
        return n;
    }
    return function e(...s) {
        ea(t);
        return n.apply(this, s);
    };
};

const ra = (t, n) => {
    const e = t.ii;
    const s = typeof t.Mt === "string";
    s && !t.$ && (t.$ = n || xf()?.$);
    if (t.resolved) {
        return;
    }
    const o = fa();
    const r = xf();
    const i = e.ei();
    const c = Gi(i, n => {
        t.resolved = ia(t, n);
    });
    if (c) {
        const t = e._t;
        ua(t, r?.m instanceof Gr ? r?.m.node : void 0, o);
    }
    const l = s && t.$ && ea(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const sa = (t, n, e, s, o, r) => {
    const i = zf(t, n, s, e, r);
    const c = new Jf(i, o, r);
    return oa(c);
};

const oa = t => {
    const n = async function(...t) {
        return Yf.call(n, this, ...t);
    };
    n[Qf] = t;
    Object.setPrototypeOf(n, Kf);
    return n;
};

const la = /*#__PURE__*/ new Set;

const ua = (t, n, e) => {
    if (!la.has(t)) {
        la.add(t);
        ca("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const ca = (t, n) => {
    rd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const fa = () => {
    if (rd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let aa = 0;

const ha = t => sa(null, "s" + aa++, t, null, null);

const da = ha;

const pa = t => t;

const $a = t => sa("", Ge, t, null, null);

const ya = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return sa("", Ge, t, null, null);
};

const ma = t => {
    function n(n, e, s = 0) {
        const o = t.st.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[wa] = [ t ];
        return fo(i, n, null, n.children, s, r);
    }
    n[wa] = [ t ];
    return n;
};

const wa = Symbol();

const va = t => typeof t == "function" && t[wa] !== void 0;

const ba = t => ma(da(t));

const _a = xs(pa);

const ga = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Ea = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Wr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Si, "resumed");
    const s = Ee(t);
    s.un = e.serverData || {};
    const o = s.rootVNode;
    gl(o, is, n);
    yn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Et(s, [], s.rootVNode);
        }
    };
};

const Sa = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e != null) {
        return e;
    }
    const r = Je(t) ? qe(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Bu(r, i, t);
        s(c);
        return c;
    }
};

const ka = () => {
    const {val: t, set: n, iCtx: e} = Wo();
    if (t != null) {
        return t;
    }
    const s = e.$.We || "";
    const o = s ? lr(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e.m, si);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.De;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.Xe++);
    })(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Ie(t, n) {
    const e = xf();
    return e?.$?.un[t] ?? n;
}

const Ra = /*#__PURE__*/ new Map;

const Pa = (t, n) => {
    let e = Ra.get(n);
    e || Ra.set(n, e = Ta(t, n));
    return e;
};

const Ta = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = Ia;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === oh) {
            r++;
            e = ih;
        }
        const s = ph[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, w] = p;
            if (($ === l || $ === Wa || $ === Va && qa(l) || $ === za && xa(l)) && (y === e || y === Wa || y === Va && qa(e) || y === Ua && !qa(e) && e !== Za || y === za && xa(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (w === Da || w == Xa) {
                    if (w === Xa) {
                        if (c !== Na || h()) {
                            if (!Aa(e)) {
                                const t = y == Ua ? 1 : y == Ga ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            Aa(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === Ua) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || Ia;
                        if (c === Ca) {
                            u(r - 1);
                            i++;
                        }
                    } while (Ma(c));
                } else {
                    o.push(c);
                    if (c === Ca && w === Ia) {
                        u(r - 8);
                        i = r;
                    } else {
                        w === Oa && f(n);
                    }
                    c = w;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === Ca || h()) {
            return;
        }
        u(t);
        s.push(".", li, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ka) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ka) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | uh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(Ca) !== -1 || o.indexOf(ja) !== -1;
    }
};

const qa = t => t >= th && t <= nh || t >= ih && t <= rh || t >= ch && t <= fh || t >= 128 || t === lh || t === Ka;

const Aa = t => t === eh || t === Za || t === sh || t === Ya || qa(t);

const Ma = t => t === La || t === ja || t === Fa || t === Ca;

const xa = t => t === Ja || t === Ba || t === Qa || t === Ha;

const Ia = 0;

const Na = 2;

const Ca = 5;

const Oa = 6;

const ja = 10;

const La = 11;

const Fa = 12;

const Da = 17;

const Xa = 18;

const Wa = 0;

const Va = 1;

const Ua = 2;

const za = 3;

const Ba = 9;

const Qa = 10;

const Ha = 13;

const Ja = 32;

const Ya = 35;

const Ga = 41;

const Ka = 45;

const Za = 46;

const th = 48;

const nh = 57;

const eh = 58;

const ih = 65;

const rh = 90;

const sh = 91;

const oh = 92;

const lh = 95;

const uh = 32;

const ch = 97;

const fh = 122;

const ah = 123;

const hh = 125;

const dh = /*@__PURE__*/ (() => [ [ Wa, 39, 14 ], [ Wa, 34, 15 ], [ Wa, 47, 16, "*" ] ])();

const ph = /*@__PURE__*/ (() => [ [ [ Wa, 42, Na ], [ Wa, sh, 7 ], [ Wa, eh, Oa, ":", "before", "after", "first-letter", "first-line" ], [ Wa, eh, Ca, "global" ], [ Wa, eh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ Wa, eh, 4 ], [ Wa, Va, 1 ], [ Wa, Za, 1 ], [ Wa, Ya, 1 ], [ Wa, 64, ja, "keyframe" ], [ Wa, 64, La, "media", "supports", "container" ], [ Wa, 64, Fa ], [ Wa, ah, 13 ], [ 47, 42, 16 ], [ Wa, 59, Da ], [ Wa, hh, Da ], [ Wa, Ga, Da ], ...dh ], [ [ Wa, Ua, Xa ] ], [ [ Wa, Ua, Xa ] ], [ [ Wa, 40, Ia ], [ Wa, Ua, Xa ] ], [ [ Wa, 40, 8 ], [ Wa, Ua, Xa ] ], [ [ Wa, 40, Ia ], [ Wa, Ua, Da ] ], [ [ Wa, Ua, Da ] ], [ [ Wa, 93, Xa ], [ Wa, 39, 14 ], [ Wa, 34, 15 ] ], [ [ Wa, Ga, Da ], ...dh ], [ [ Wa, hh, Da ], ...dh ], [ [ Wa, hh, Da ], [ za, Va, 1 ], [ Wa, eh, Ca, "global" ], [ Wa, ah, 13 ], ...dh ], [ [ Wa, ah, Ia ], [ Wa, 59, Da ], ...dh ], [ [ Wa, 59, Da ], [ Wa, ah, 9 ], ...dh ], [ [ Wa, hh, Da ], [ Wa, ah, 13 ], [ Wa, 40, 8 ], ...dh ], [ [ Wa, 39, Da ] ], [ [ Wa, 34, Da ] ], [ [ 42, 47, Da ] ] ])();

const $h = t => ({
    styleId: vh(t, t => t, !1)
});

const yh = /*#__PURE__*/ xs($h);

const mh = t => ({
    scopeId: li + vh(t, Pa, !0)
});

const wh = /*#__PURE__*/ xs(mh);

const vh = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Wo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${lr(t.st)}-${n}`)(t, i);
    const l = r.m;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Ke(n(t, c), c, l, e));
    }
    r.$.Ke(n(t.resolved, c), c, l, e);
    return c;
};

const bh = (t, n) => {
    t.resolve();
    return Os(t, n);
};

const _h = (t, n) => zo(bh, t, n);

const gh = xs(_h);

const Eh = t => {
    t.resolve();
    return Ls(t);
};

const Sh = t => zo(Eh, t);

const kh = xs(Sh);

const Rh = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Wo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !rd()) {
            e.h |= 32;
            Ph(e, i);
        }
        return;
    }
    let c;
    if (rd()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        yn(r.$, r.m, 1);
    }
    const l = new Ru(c, o, r.m, t, null);
    s(l);
    Ph(l, i);
};

const Ph = (t, n) => {
    n === "intersection-observer" ? Vc("qvisible", Th(t)) : n === "document-ready" ? Uc("qinit", Th(t)) : n === "document-idle" && Uc("qidle", Th(t));
};

const Th = t => sa(null, "_task", An, null, [ t ]);

const qh = xs(Dc);

const Ah = /*#__PURE__*/ xs(Su);

const Mh = /*#__PURE__*/ xs(Rh);

const xh = (t, n) => {
    t.resolve();
    return js(t, n);
};

const Ih = (t, n) => zo(xh, t, n);

const Nh = xs(Ih);

const Ch = () => {
    const t = Sa({
        error: void 0
    });
    mf(bf, t);
    return t;
};

const Oh = async ({track: t}) => {
    const n = Zf[0];
    t(() => n.items);
    const e = xf();
    const s = e.m;
    const o = e.$;
    yn(o, s, 256);
    const r = Ce;
    r && await o.l;
};

const jh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Su(/*#__PURE__*/ kc(Oh, "_eaT", [ t ]));
    return go;
};

const Lh = /*#__PURE__*/ ma(
/*#__PURE__*/ kc(jh, "_eaC"));

const Fh = (t, n, e) => Ke(t) ? t.getFn(n)(e) : t(e);

const Dh = ({track: t}) => {
    const n = Zf[0];
    const e = xf();
    const s = e.m;
    const o = e.$;
    const r = Ce;
    return Gi(t(() => Fh(n.when$, xf(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return Gi(i ? Fh(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Ut(s, n);
            yn(o, s, 2);
        });
    });
};

const Xh = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Su(/*#__PURE__*/ kc(Dh, "_shT", [ t ]));
    return go;
};

const Wh = /*#__PURE__*/ ma(
/*#__PURE__*/ kc(Xh, "_shC"));

const Vh = /*#__PURE__*/ yf("qk-reveal");

const Uh = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Fs(0)
});

const zh = () => {
    const t = Zf[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Oe) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return ad(t);
};

const Bh = ({cleanup: t}) => {
    const n = Zf[0];
    t(() => {
        if (!Oe) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Qh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = zo(Uh, t);
    mf(Vh, n);
    const e = !Oe;
    if (__EXPERIMENTAL__.suspense && e && $d()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                if (!$d()) {
                    return null;
                }
                const e = xf()?.$;
                let s = 0;
                if (e) {
                    s = (hd.get(e) || 0) + 1;
                    hd.set(e, s);
                }
                return new dd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = df(e);
            return e;
        })(n);
        /*#__PURE__*/
        return co(wd, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    /*#__PURE__*/
    return co(_o, null, null, null, 0, "u7_0");
};

const Hh = /*#__PURE__*/ ma(
/*#__PURE__*/ kc(Qh, "_reC"));

const wd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ fd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ co(_o, null, null, null, 0, "u7_0"));
}) : null;

const Jh = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const md = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Yh = (t, n, e) => ({
    display: n.value !== "content" && !t.showStale || e !== null && !e.value ? "none" : "contents"
});

const Gh = ({track: t, cleanup: n}) => {
    const e = Zf[0], s = Zf[1], o = Zf[2], r = Zf[3];
    const i = t(e.pending);
    const c = Oe;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Kh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Uo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return zo(Bo);
    })();
    const s = (t => {
        const n = wf(Vh, null);
        const e = zo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Su(/*#__PURE__*/ kc(Bh, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = _h(
    /*#__PURE__*/ kc(zh, "_reR", [ s ]));
    Su(
    /*#__PURE__*/ kc(Gh, "_suT", [ e, t, n, s ]));
    const r = !Oe;
    const i = r && $d();
    const c = i ? (() => {
        if (!__EXPERIMENTAL__.suspense) {
            return 0;
        }
        const t = xf()?.$;
        if (t?.outOfOrderStreaming !== !0) {
            return 0;
        }
        return t?.nextOutOfOrderId?.() ?? 0;
    })() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && function f(t, n) {
        return t != null && t !== !1 && (n === null || n.showFallback);
    }(t.fallback, l);
    const a = u && _d(t.delay) ? {
        contentResolved: !1,
        delayTimer: null
    } : null;
    const h = i ? /*#__PURE__*/ Nc(Jh, [ t, n, o, s ], md) : null;
    const d = /*#__PURE__*/ Nc(Yh, [ t, n, o ], '{display:(p1.value==="content"||p0.showStale)&&(p2===null||p2.value)?"contents":"none"}');
    const p = i ? /*#__PURE__*/ co(bd, {
        boundary: a,
        delay: t.delay,
        fallbackStyle: h,
        showFallback: u,
        state: n
    }, null, Bs(t, "fallback"), 1, null) : /*#__PURE__*/ co("div", {
        style: Nc(Jh, [ t, n, o, s ], md)
    }, null, Bs(t, "fallback"), 1, null);
    return [ p, 
    /*#__PURE__*/ co("div", null, i ? {
        [od]: c + "",
        style: d
    } : {
        style: d
    }, 
    /*#__PURE__*/ co(i ? vd : _o, i ? {
        [Ri]: e,
        boundary: a,
        boundaryId: c,
        contentStyle: d,
        reveal: l
    } : {
        [Ri]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Zh = /*#__PURE__*/ ma(
/*#__PURE__*/ kc(Kh, "_suC"));

const bd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ fd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.delay;
    const i = n.varProps.fallbackStyle;
    const c = n.varProps.showFallback === !0;
    const l = n.varProps.state;
    c && !_d(r) ? l.value = "fallback" : o && c && _d(r) && s(() => function n(t, e, s, o) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, o);
    }(t, o, l, r));
    s(
    /*#__PURE__*/ co("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const vd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ fd(async (t, n, e) => {
    const s = n.varProps.boundaryId ?? t.nextOutOfOrderId();
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            /*#__PURE__*/
            return co(_o, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        /*#__PURE__*/
        return co(_o, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    (function f(t, n) {
        t.write(`<template ${ai}="${n}"></template>`);
    })(t, s);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, r, i, c) {
        (function l(t) {
            if (!t) {
                return;
            }
            t.contentResolved = !0;
            if (t.delayTimer) {
                clearTimeout(t.delayTimer);
                t.delayTimer = null;
            }
        })(c);
        i?.resolve();
        await t.S(async () => {
            t.addRoot(r);
            const e = await o.container.P(s, o);
            (function c(t, n, e, s) {
                t.write(`<template ${ai}="${n}"${s?.attrs ?? ""}>`);
                t.write(e);
                t.write("</template>");
            })(t, n, e.html, i);
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, i, c, r)));
}) : null;

function _d(t) {
    return typeof t === "number" && Number.isFinite(t) && t > 0;
}

const td = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = nd.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return co("script", null, o, null, 0, "prefetch-service-worker");
};

const nd = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const ed = () => null;

globalThis.__qwik && Ye(30, [ globalThis.__qwik, Xr ]);

globalThis.__qwik = Xr;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { ha as $, Lh as Each, vo as Fragment, pf as NoSerializeSymbol, ed as PrefetchGraph, td as PrefetchServiceWorker, bo as RenderOnce, Xc as Resource, Hh as Reveal, So as SSRComment, Eo as SSRRaw, Ro as SSRStream, ko as SSRStreamBlock, $f as SerializerSymbol, Wh as Show, go as SkipRender, _o as Slot, Zh as Suspense, ls as _CONST_PROPS, qf as _DomContainer, Vr as _EFFECT_BACK_REF, Oi as _ELEMENT_SEQ, ds as _EMPTY_ARRAY, ps as _EMPTY_OBJ, as as _IMMUTABLE, Cc as _SharedContainer, Ys as _SubscriptionData, Ku as _SubscriptionPatch, Ru as _Task, hs as _UNINITIALIZED, us as _VAR_PROPS, Yn as _addProjection, Zf as _captures, b as _chk, fe as _createDeserializeContainer, sa as _createQRL, xn as _createStore, Ki as _delay, ue as _deserialize, yc as _dumpState, jh as _eaC, Oh as _eaT, pn as _executeSsrChores, Nc as _fnSignal, Ic as _getAsyncLocalStorage, _s as _getConstProps, Wf as _getContextContainer, Xf as _getContextEvent, Df as _getContextHostElement, Ee as _getDomContainer, ke as _getQContainerElement, w as _getSubscriber, bs as _getVarProps, Vu as _hasStoreEffects, Hc as _hmr, Cs as _injectAsyncSignalValue, qe as _invoke, Zs as _isJSXNode, zu as _isStore, Vn as _isStringifiable, Pu as _isTask, Vf as _jsxBranch, ao as _jsxC, po as _jsxQ, ho as _jsxS, co as _jsxSorted, fo as _jsxSplit, Xe as _mapApp_findIndx, Ve as _mapArray_get, We as _mapArray_set, ju as _markSignalAsExternallyOwned, xe as _newInvokeContext, Rc as _noopQrl, Pc as _noopQrlDEV, Dn as _preprocessState, ya as _qrlSync, On as _qrlToString, Tc as _qrlWithChunk, qc as _qrlWithChunkDEV, Qh as _reC, zh as _reR, Bh as _reT, xc as _regSymbol, Zn as _removeProjection, _ as _res, vf as _resolveContextWithoutSequentialScope, Mo as _restProps, n as _retryOnPromise, Fc as _rsc, I as _run, le as _serialize, Qn as _setEvent, Gn as _setProjectionTarget, Xh as _shC, Dh as _shT, Kh as _suC, Gh as _suT, An as _task, Kn as _updateProjectionProps, Jn as _useHmr, v as _val, uf as _verifySerializable, kl as _vnode_ensureElementInflated, pu as _vnode_getAttrKeys, Ql as _vnode_getElementName, Yl as _vnode_getFirstChild, _l as _vnode_getProp, xl as _vnode_getVNodeForChildNode, Wl as _vnode_insertBefore, $l as _vnode_isElementVNode, ml as _vnode_isMaterialized, wl as _vnode_isTextVNode, vl as _vnode_isVirtualVNode, dl as _vnode_newVirtual, zl as _vnode_remove, gl as _vnode_setProp, En as _vnode_toString, Uf as _waitUntilRendered, zn as _walkJSX, Bs as _wrapProp, Hs as _wrapSignal, ba as component$, ma as componentQrl, Xs as createAsync$, js as createAsyncQrl, Ds as createComputed$, Os as createComputedQrl, yf as createContextId, g as createElement, Ws as createSerializer$, Ls as createSerializerQrl, Fs as createSignal, _a as event$, pa as eventQrl, Wu as forceStoreEffects, ga as getClientManifest, Ee as getDomContainer, Pe as getLocale, mr as getPlatform, g as h, xs as implicit$FirstArg, kc as inlinedQrl, Mc as inlinedQrlDEV, je as isDev, qu as isSignal, yo as jsx, mo as jsxDEV, wo as jsxs, df as noSerialize, Sc as qrl, Ac as qrlDEV, Ea as render, yr as setPlatform, $a as sync$, Of as untrack, Uu as unwrapStore, Nh as useAsync$, Ih as useAsyncQrl, gh as useComputed$, _h as useComputedQrl, zo as useConstant, wf as useContext, mf as useContextProvider, Ch as useErrorBoundary, ka as useId, Lc as useLexicalScope, Vc as useOn, Uc as useOnDocument, zc as useOnWindow, qh as useResource$, Dc as useResourceQrl, kh as useSerializer$, Sh as useSerializerQrl, Ie as useServerData, Uo as useSignal, Sa as useStore, yh as useStyles$, $h as useStylesQrl, wh as useStylesScoped$, mh as useStylesScopedQrl, Ah as useTask$, Su as useTaskQrl, Mh as useVisibleTask$, Rh as useVisibleTaskQrl, Xr as version, Te as withLocale };
